import PageHeader from "../components/common/PageHeader";
import { useEffect, useRef, useState } from "react";
import GoToTop from "../helpers/GoToTop";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ApiService from "../api/ApiService";
import { useForm, Controller } from "react-hook-form";
import notification from "../helpers/notification";
import MetaData from "../helpers/MetaData";
import { BsCheckLg } from "react-icons/bs";
import Fancybox from "../helpers/Fancybox";
import Skeleton from "react-loading-skeleton";
import { BsFillPlayCircleFill } from "react-icons/bs";
import ReCAPTCHA from "react-google-recaptcha";
import { useContext } from "react";
import AppContext from "../context/AppContext";
import { useCallback } from "react";
import axios from "axios";
import moment from "moment/moment";
import Select from "react-select";
import Tooltip from "@mui/material/Tooltip";
import { AiOutlineCalendar } from "react-icons/ai";
import { schemeName } from "../constants/data/nityaSevaData";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "../css/nityaSevaForm.scss";

const expiry = process.env.REACT_APP_OTPEXPIRY;
let timer = null;

const sevaOptions = ["Annadaan Seva", "Sadhu Bhojan Seva", "Deity Worship"];
const amountOptions = [100, 500, 1000, 2500];
const dropdownAmounts = [2500, 5000, 7500, 10000, 15000, 20000, 25000, 50000];

const NityaSevaForm = () => {
  const nityaAmount = localStorage.getItem("nitya-seva-amt");

  //console.log(nityaAmount);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
    getValues,
    control,
  } = useForm({
    defaultValues: {
      state: "",
      city: "",
    },
  });

  const scrollToElement = () => {
    const element = document.getElementById("scrollToDonateFrom");
    // console.log("elements",element);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // const formRef = useRef();
  const navigate = useNavigate();
  const { slug } = useParams();
  const { setToken, user, token, donor, profiles } = useContext(AppContext);

  if (nityaAmount === "") {
    navigate("/nitya_seva_subscribe");
  }

  // if(!user){
  //   navigate('/login?sub=1')
  // }

  const search = useLocation().search;
  const donationId = new URLSearchParams(search).get("donationId");

  const [donationTypes, setDonationTypes] = useState([null]);
  const [popularDonation, setPopularDonations] = useState([]);
  const [donationType, setDonationType] = useState(null);
  const [donationImg, setDonationImg] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [categories, setCategories] = useState([]);
  const [type, setType] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRetry, setIsRetry] = useState(false);
  const [retryDonationDetails, setRetryDonationDetails] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedSeva, setSelectedSeva] = useState("Annadaan Seva");
  const [selectedAmount, setSelectedAmount] = useState(100);
  const [shownForm, setShownForm] = useState(false);
  const [showMemoryBox, setShowMemoryBox] = useState(false);
  const [goseva, setGoseva] = useState(0);
  const [bhagavadGitaPrice, setBhagavadGitaPrice] = useState(0);
  const [isGoseva, setIsGoseva] = useState(false);
  const [isSadhuBhojanSeva, setIsSadhuBhojanSeva] = useState(false);
  const [isBhagvadGita, setIsBhagvadGita] = useState(false);
  const [top, setTop] = useState(0);
  const [showOtp, setShowOtp] = useState(false);
  const [isVerified, setIsverified] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpExp, setOtpExp] = useState(expiry);
  const [showresendlink, setShowResendLink] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [icsdontype, setIcsDontype] = useState("A General Donation");
  const [ics_data, setICSdata] = useState();
  const [ics_address, setIcsAddress] = useState([]);
  const [ics_pincode, setIcsPincode] = useState([]);
  const [icsdatawl, setICSdatawl] = useState([]);
  const [item_data, setItemData] = useState([]);
  const [wl_loginics, setWithlogin] = useState([]);
  const [wl_icsname, setIcsname] = useState("");
  const [icsid, setICSid] = useState(localStorage.getItem("ics_id"));

  const [recieptId, setRecieptId] = useState("");

  const currentDate = new Date();
  const formattedDate = currentDate.toDateString();

  const fetchStateCity = async (pin) => {
    try {
      let url = `https://api.postalpincode.in/pincode/${pin}`;

      let config = {
        method: "GET",
        url,
      };
      const { data } = await axios(config);

      let cityVal = "";
      if (data[0]?.PostOffice?.length > 1) {
        data[0]?.PostOffice.map((ct) => {
          if (ct.Block !== "NA") {
            return (cityVal = ct.Block);
          }
        });
      } else {
        cityVal = data[0]?.PostOffice[0]?.Block;
      }

      if (data[0]?.Status === "Success") {
        setValue(
          "city",
          cityVal !== "" ? cityVal : data[0]?.PostOffice[0]?.District
        );
        setValue("state", data[0]?.PostOffice[0]?.State);
      } else {
        notification("warning", "Enter valid PIN code!");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const formRef = useCallback((node) => {
    if (node) {
      setTop(node.offsetTop);
    }
  });

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize(); // Check initially
    window.addEventListener("resize", checkScreenSize); // Add resize listener

    return () => window.removeEventListener("resize", checkScreenSize); // Cleanup
  }, []);

  useEffect(() => {
    reset({
      schemeName: "",
      amount: "2020",
      interval: "3",
      startDate: "",
      endDate: "",
    });
  }, []);

  useEffect(() => {
    scrollToElement();
  }, []);

  useEffect(() => {
    const showBox = watch((value) => {
      const { amount, sadhuBhojanSeva, bhagavadGita, goseva } = value;
      // console.log(value)
      let total =
        (amount ? Number(amount) : 0) +
        (sadhuBhojanSeva ? Number(sadhuBhojanSeva) : 0) +
        (bhagavadGita ? Number(bhagavadGita) * 200 : 0) +
        (goseva ? Number(goseva) * 120 : 0);
      setTotalAmount(total);

      setShowMemoryBox(value.memoryOfSomeone);
    });
    return () => showBox.unsubscribe();
  }, [watch]);

  const recaptchaRef = useRef();

  const fetchDonationType = async () => {
    try {
      const res = await ApiService.fetchDonationService(slug);
      //console.log(res.donationType);
      setDonationType(res.donationType);
      setIsGoseva(res.donationType.goseva);
      setIsSadhuBhojanSeva(res.donationType.sadhuBhojanSeva);
      setIsBhagvadGita(res.donationType.bhagvadGita);
      if (res.donationType.popular) {
        setPopularDonations(res.donationTypes);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPopularDonations = async () => {
    try {
      const res = await ApiService.fetchPopularDonations();
      // console.log(res)
      setPopularDonations(res);
      if (!slug) {
        setDonationImg(res[0].image);
        setVideoUrl(res[0].videoUrl);
        setIsGoseva(res[0].goseva);
        setIsSadhuBhojanSeva(res[0].sadhuBhojanSeva);
        setIsBhagvadGita(res[0].bhagvadGita);

        let details = {};
        if (!isRetry) {
          details.donationType = res[0]?._id;
        }

        if (user && !isRetry) {
          details.name = user?.name;
          details.phone = user.phone;
          details.email = user.email;
          details.pan = user.pan;
          details.address =
            user.streetName && user.areaName
              ? `${user.streetName}, ${user.areaName}`
              : user.address;
          details.pin = user.pin;
          details.state = user?.state;
          details.city = user?.city;
        }
        reset(details);
        if (user?.pin) {
          fetchStateCity(user?.pin);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!slug) {
      fetchPopularDonations();
    } else {
      // formRef.current.scrollIntoView({ behavior: "smooth" });
      fetchDonationType();
    }
    if (user) {
      setIsverified(true);
    }
  }, [isRetry, donationId, user]);

  useEffect(() => {
    if (donationType?.popular) {
      let details = { donationType: donationType?._id };
      if (user && !isRetry) {
        details.name = user.name;
        details.phone = user.phone.trim();
        details.email = user.email;
        details.pan = user.pan;
        details.address =
          user.streetName && user.areaName
            ? `${user.streetName}, ${user.areaName}`
            : user.address;
        details.pin = user.pin;
        details.state = user?.state;
        details.city = user?.city;
      }
      reset(details);
      if (user?.pin) {
        fetchStateCity(user?.pin);
      }
    } else {
      let details = {
        donationType: donationType?.title
          ? donationType?.title.split("|")[0] +
            " " +
            (donationType?.title?.split("|").length !== 1
              ? donationType?.title?.split("|")[1]
              : "")
          : "",
        amount: donationType?.amount,
      };

      if (user && !isRetry) {
        details.name = user.name;
        details.phone = user.phone.trim();
        details.email = user.email;
        details.pan = user.pan;
        details.address =
          user.streetName && user.areaName
            ? `${user.streetName}, ${user.areaName}`
            : user.address;
        details.pin = user.pin;
        details.state = user?.state;
        details.city = user?.city;
      }
      reset(details);
      if (user?.pin) {
        fetchStateCity(user?.pin);
      }
    }
    setDonationImg(donationType?.image);
    setVideoUrl(donationType?.videoUrl);
  }, [donationType, user, isRetry]);

  function getTime(time) {
    return (
      Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2)
    );
  }

  const madeDonationNityaseva = async (data) => {
    console.log("manData", data);
    console.log("donationType", donationType); // Debug donationType

    try {
      const token = await recaptchaRef.current.executeAsync();
      //const ics_id = localStorage.getItem("ics_id");
      data.token = token;

      data.name = wl_icsname ? wl_icsname : data.name;

      data.icsid = icsid ? icsid : "";

      data.userType = user ? "user" : "guest";
      if (donor) {
        data.donorId = donor?.id;
      }

      let _doonationType;
      if (isRetry) {
        _doonationType = retryDonationDetails.donationType;
      } else {
        _doonationType =
          popularDonation.length > 0 || (donationType && donationType.popular)
            ? data.donationType
            : donationType?._id || ""; // Fallback to empty string if donationType is null
      }

      // Ensure amount is a number and convert to paise for Razorpay
      const amountInPaise = Number(data.amount ?? selectedAmount) * 100;

      const res = await ApiService.subscribeNityaSevaAutopay({
        ...data,
        type,
        donationType: _doonationType,
        amount: Number(data.amount ?? selectedAmount),
        schemaname: data.schemaname || selectedSeva || "Nitya Seva",
      });

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,

        name: process.env.REACT_APP_PROJECT_NAME,
        amount: amountInPaise,
        subscription_id: res.subscriptionId,
        description: `Nitya Seva - ${data.schemaname || "Nitya Seva"}`,
        image: `${process.env.REACT_APP_S3_URL}/assets/img/logo.jpg`,
        handler: function (response) {
          // console.log("responce", response);
          const textForStorage = response.razorpay_payment_id;
          localStorage.setItem("my-key", textForStorage);
          const textFromStorage = localStorage.getItem("my-key");

          if (textFromStorage) {
            // sendDonationICS(data, res.donationId, final_amt);
            navigate(`/thank-you/${res.nityaSevaId}/subscription`, {
              replace: true,
            });
          }
        },
        prefill: {
          name: res.name || data.name || "",
          email: res.email || data.email || "",
          contact: res.phone || data.phone || "",
        },
        notes: {
          type: "donation",
          schemaname: data.schemaname || "Nitya Seva",
        },
        theme: {
          color: "#FFD370",
        },
        modal: {
          ondismiss: async function () {
            await ApiService.cancelDonation(res.id);
          },
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", function (response) {
        // console.log(response)
        navigate(`/payment-failed?id=${res.donationId}&&type=donation`, {
          replace: true,
        });
      });
      setLoading(false);
      setShownForm(false);
      setSelectedSeva("");
      setSelectedAmount("");
    } catch (err) {
      setLoading(false);
      console.log("Error in madeDonationNityaseva:", err);
      notification("error", "Unable to make donation, try again later!");
    }
  };

  const handleNityaSevaSub = async (data) => {
    setLoading(true);
    madeDonationNityaseva(data);
  };

  const resendOtp = () => {
    setOtpExp(expiry);
    // handleSendOtp(getValues("phone"));
    setShowResendLink(false);
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const cardItems = [
    {
      title: "Support Daily Worship",
      text: "Your regular offering helps maintain the daily aarti, bhoga offerings, and floral decorations of Sri Sri Radha Madhava, ensuring Their worship continues without interruption.",
      svg: (
        <svg
          width="32"
          height="31"
          viewBox="0 0 32 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.6846 11.3945L28.0068 11.3984C28.6467 11.4356 29.2605 11.6507 29.7783 12.0352V12.0107L30.0293 12.2402C31.3008 13.4005 31.4397 15.3639 30.373 16.6924L30.2666 16.8193L21.8467 26.2852C19.589 28.8209 16.3503 30.2754 12.96 30.2754H5.58105C3.11054 30.2754 1.10078 28.2627 1.10059 25.7891V19.5938C1.10072 17.1201 3.1105 15.1074 5.58105 15.1074H17.7764C19.2468 15.1075 20.5014 16.0425 20.9834 17.3477L25.4277 12.457L25.54 12.3398C26.1131 11.7676 26.8685 11.4335 27.6826 11.3945H27.6846ZM27.5859 12.9512C27.2498 13.0003 26.9392 13.1463 26.6875 13.374L26.5664 13.4951L21.0234 19.5938C20.6266 20.8009 19.5707 21.7353 18.2598 21.9229L18.2568 21.9238L10.6211 22.8379L10.6201 22.8369C10.2214 22.8926 9.86277 22.62 9.7793 22.2422L9.7666 22.165C9.71613 21.7427 10.0168 21.3591 10.4385 21.3096L18.0605 20.3965C18.9648 20.2655 19.6572 19.4642 19.6572 18.5332C19.6571 17.4935 18.8109 16.6475 17.7744 16.6475H5.58105C3.95817 16.6475 2.6377 17.9698 2.6377 19.5957V25.79C2.63775 27.4159 3.9582 28.7373 5.58105 28.7373H12.96C15.9121 28.7373 18.7344 27.471 20.7002 25.2617L29.1191 15.7969L29.1504 15.7607C29.7385 15.0582 29.6741 14.0035 28.9941 13.3828V13.3818C28.655 13.0707 28.2139 12.9118 27.7568 12.9346L27.5859 12.9512ZM2.19922 1.2373C3.95647 0.473224 7.47385 -0.529832 11.2363 1.41016L11.4512 1.52832C12.5056 2.14283 13.2624 3.13641 13.5938 4.34766L13.6553 4.59766C13.9115 5.76693 13.7375 6.98723 13.166 8.01758L13.0381 8.23535C12.9186 8.4264 12.7887 8.5926 12.6602 8.74805C12.8219 9.04437 12.9709 9.34084 13.0996 9.63477C13.4874 8.97308 14.0475 8.28989 14.8369 7.70996C14.3654 6.00031 15.3036 4.17435 17.0947 3.37207L17.3164 3.27734C19.6046 2.34297 21.9664 2.74962 23.5557 3.26074L23.7705 3.34375C24.2556 3.56387 24.6346 3.96699 24.8057 4.46094L24.8633 4.66309C24.9532 5.07122 24.8963 5.49324 24.7031 5.86523L24.5957 6.04688C23.4228 7.78082 22.136 9.06054 20.7637 9.84668L20.4873 9.99805C19.8994 10.3027 19.2557 10.457 18.6084 10.457C18.1408 10.457 17.6713 10.3762 17.2207 10.2139L17.0293 10.1396C16.456 9.90022 15.9759 9.52619 15.5938 9.07422C14.3646 10.0604 13.9412 11.3883 13.8066 12.0352L13.7646 12.2734C13.7094 12.6518 13.3843 12.9326 13.0029 12.9326H12.9893C12.6506 12.9259 12.3622 12.6998 12.2676 12.3857L12.2393 12.2461C12.1581 11.5024 11.9074 10.6556 11.4727 9.78027C10.5043 10.3642 9.5344 10.4629 9.04492 10.4629C8.22032 10.4629 7.30836 10.3177 6.57422 10.0137L6.27148 9.87402C4.21874 8.81559 2.98238 6.81417 2.03027 5.04688L1.6377 4.30664L1.30664 3.68164V3.68262C1.07677 3.25333 1.03712 2.76369 1.19434 2.30762L1.26562 2.13379C1.45259 1.73926 1.78686 1.42013 2.19922 1.23828L2.25977 1.375L2.19922 1.2373ZM10.5361 2.77734C7.34182 1.13094 4.33084 1.98648 2.81445 2.64844L2.78516 2.66016C2.71273 2.69991 2.66599 2.7548 2.64844 2.80664V2.80762C2.63653 2.84317 2.63527 2.87805 2.64648 2.91406L2.66211 2.95117L2.66309 2.95215L2.99805 3.58496L3.37402 4.29395C4.26902 5.95732 5.31306 7.64411 6.97559 8.50098L7.18164 8.59766C7.67133 8.80786 8.2202 8.90381 8.80176 8.91016H8.81348L8.7998 9.05566L8.81348 8.91113C8.91254 8.91994 9.80294 8.99161 10.6836 8.45996C9.81672 7.25375 8.56468 6.06813 6.83008 5.09863L6.46387 4.90039C6.08773 4.70479 5.94016 4.24034 6.13672 3.86328L6.17676 3.79492C6.39146 3.47052 6.82485 3.35293 7.17383 3.53711H7.17285C9.21865 4.6042 10.7151 5.95202 11.7676 7.35156C12.2544 6.57895 12.3392 5.7313 12.1572 4.9248L12.1143 4.75293C11.89 3.93339 11.3815 3.26536 10.6787 2.85547L10.5361 2.77734ZM23.0889 4.72461C21.7688 4.30123 19.8755 3.96866 18.082 4.62988L17.7246 4.77539C16.5886 5.28316 16.0242 6.36128 16.3213 7.31738L16.4072 7.54883C16.6363 8.07312 17.0581 8.48388 17.6211 8.71777L17.752 8.76758C18.413 8.99972 19.162 8.94983 19.7803 8.62988L20.0107 8.50391C21.1617 7.84239 22.278 6.7295 23.3242 5.18262C23.3834 5.09346 23.3729 5.01401 23.3545 4.96191V4.96094C23.3289 4.88525 23.2709 4.8157 23.1846 4.7666L23.0889 4.72461Z"
            fill="#FFC84F"
            stroke="#FFC84F"
            stroke-width="0.3"
          />
        </svg>
      ),
    },
    {
      title: "Feed Thousands Daily",
      text: "ISKCON Bhiwandi distributes sanctified vegetarian meals (prasadam) to schoolchildren, devotees, and the needy. Your contribution fuels this essential seva.",
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_99_781)">
            <path
              d="M16 0.0996094C20.2155 0.104195 24.2574 1.78088 27.2383 4.76172C30.2191 7.74255 31.8958 11.7845 31.9004 16L31.8887 16.5889C31.7871 19.3314 30.9773 22.0011 29.5381 24.3379L29.2207 24.834C27.5827 27.2853 25.2972 29.2291 22.624 30.4541L22.085 30.6895C19.3612 31.8177 16.3808 32.1648 13.4775 31.6982L12.8984 31.5947C9.81414 30.9812 6.98049 29.4668 4.75684 27.2432C2.67207 25.1584 1.21123 22.5377 0.53125 19.6768L0.405273 19.1016C-0.169747 16.2103 0.0709953 13.22 1.09473 10.4639L1.31055 9.91504C2.43871 7.19159 4.30015 4.83915 6.68262 3.11621L7.16602 2.7793C9.61729 1.14141 12.4727 0.220206 15.4111 0.111328L16 0.0996094ZM21.1406 3.58887C18.8396 2.63578 16.3218 2.34227 13.8691 2.73633L13.3789 2.8252C10.9361 3.31119 8.67979 4.46583 6.85938 6.15625L6.50098 6.50098C4.73963 8.26232 3.50516 10.4765 2.93066 12.8936L2.8252 13.3789C2.33926 15.8219 2.54213 18.3489 3.40723 20.6777L3.58887 21.1406C4.6056 23.5952 6.32803 25.6929 8.53711 27.1689C10.6082 28.5528 13.0202 29.3319 15.5029 29.4238L16 29.4336C19.4502 29.4298 22.7626 28.1002 25.2559 25.7275L25.4941 25.4941C28.0125 22.9758 29.4297 19.5615 29.4336 16L29.4238 15.5029C29.338 13.1857 28.6545 10.9295 27.4385 8.95508L27.1689 8.53711C25.6929 6.32802 23.5952 4.6056 21.1406 3.58887Z"
              fill="#FFC84F"
              stroke="#FFF6E1"
              stroke-width="0.2"
            />
            <path
              d="M15.9998 8.15039C16.2743 8.15039 16.5392 8.2455 16.7498 8.41797L16.8367 8.49707C17.0584 8.71889 17.1833 9.01938 17.1833 9.33301V15.8398C17.185 15.9918 17.1572 16.1425 17.1023 16.2832L17.0388 16.4199C16.9658 16.5534 16.8676 16.6716 16.7507 16.7676L16.6287 16.8555L11.5085 20.0557C11.275 20.2015 10.999 20.2605 10.7283 20.2256L10.613 20.2051C10.3449 20.1431 10.1079 19.9903 9.94116 19.7744L9.87378 19.6777C9.70715 19.4109 9.65357 19.0887 9.72437 18.7822C9.78634 18.5141 9.93908 18.2771 10.155 18.1104L10.2517 18.043L14.7458 15.2275L14.8171 15.1826V9.33301C14.8172 9.0584 14.9121 8.79353 15.0847 8.58301L15.1628 8.49707C15.3847 8.27521 15.686 8.15046 15.9998 8.15039Z"
              fill="#FFC84F"
              stroke="#FFF6E1"
              stroke-width="0.3"
            />
          </g>
          <defs>
            <clipPath id="clip0_99_781">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      title: "Join Our Mission",
      text: "By giving regularly, you help ISKCON Bhiwandi spread Krishna consciousness locally while upholding the global mission of Srila Prabhupada.",
      svg: (
        <svg
          width="29"
          height="26"
          viewBox="0 0 29 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.1432 0C19.7831 0.0215864 18.4526 0.408996 17.2862 1.1231C16.1198 1.83721 15.1587 2.85274 14.5 4.06712C13.8413 2.85274 12.8802 1.83721 11.7138 1.1231C10.5474 0.408996 9.21694 0.0215864 7.85685 0C5.68869 0.0961204 3.64594 1.06393 2.17488 2.69198C0.703813 4.32003 -0.0759849 6.47599 0.00584731 8.68884C0.00584731 14.2928 5.7866 20.4132 10.6349 24.5629C11.7174 25.4911 13.086 26 14.5 26C15.914 26 17.2826 25.4911 18.3651 24.5629C23.2134 20.4132 28.9942 14.2928 28.9942 8.68884C29.076 6.47599 28.2962 4.32003 26.8251 2.69198C25.3541 1.06393 23.3113 0.0961204 21.1432 0ZM16.813 22.6773C16.1656 23.2336 15.3464 23.5386 14.5 23.5386C13.6536 23.5386 12.8344 23.2336 12.187 22.6773C5.98106 17.3641 2.42154 12.2667 2.42154 8.68884C2.33897 7.12943 2.86405 5.59996 3.88226 4.43402C4.90047 3.26808 6.3292 2.56025 7.85685 2.46492C9.38449 2.56025 10.8132 3.26808 11.8314 4.43402C12.8496 5.59996 13.3747 7.12943 13.2922 8.68884C13.2922 9.01571 13.4194 9.32919 13.6459 9.56032C13.8724 9.79145 14.1797 9.9213 14.5 9.9213C14.8203 9.9213 15.1276 9.79145 15.3541 9.56032C15.5806 9.32919 15.7078 9.01571 15.7078 8.68884C15.6253 7.12943 16.1504 5.59996 17.1686 4.43402C18.1868 3.26808 19.6155 2.56025 21.1432 2.46492C22.6708 2.56025 24.0995 3.26808 25.1177 4.43402C26.1359 5.59996 26.661 7.12943 26.5785 8.68884C26.5785 12.2667 23.0189 17.3641 16.813 22.6723V22.6773Z"
            fill="#FFC84F"
          />
        </svg>
      ),
    },
    {
      title: "Uplift Yourself",
      text: "As your giving helps nourish others with prasadam and spiritual programs, it also brings peace, purpose, and fulfilment to your own heart.",
      svg: (
        <svg
          width="21"
          height="28"
          viewBox="0 0 21 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 8.16327C21 8.80466 20.475 9.32945 19.8333 9.32945H16.2983C15.995 13.8776 12.2033 17.4927 7.58333 17.4927H4.43333L14.735 25.9242C15.2367 26.3324 15.3067 27.0671 14.8983 27.5685C14.665 27.8484 14.3267 28 13.9883 28C13.7317 28 13.4633 27.9184 13.2533 27.7318L0.431667 17.2245C0.0466665 16.9096 -0.0933334 16.3965 0.0699999 15.93C0.233333 15.4636 0.676667 15.1603 1.16667 15.1603H7.58333C10.92 15.1603 13.6733 12.5948 13.965 9.32945H1.16667C0.525 9.32945 0 8.80466 0 8.16327C0 7.52187 0.525 6.99708 1.16667 6.99708H13.755C12.985 4.31487 10.5233 2.33236 7.58333 2.33236H1.16667C0.525 2.33236 0 1.80758 0 1.16618C0 0.524781 0.525 0 1.16667 0H19.8333C20.475 0 21 0.524781 21 1.16618C21 1.80758 20.475 2.33236 19.8333 2.33236H13.5217C14.84 3.55685 15.7733 5.17784 16.1467 6.99708H19.8217C20.4633 6.99708 20.9883 7.52187 20.9883 8.16327H21Z"
            fill="#FFC84F"
          />
        </svg>
      ),
    },
  ];

  const schemeData = [
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 100",
      amount: "100",
      image: "food-for-life-1.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 500",
      amount: "500",
      image: "food-for-life-2.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 1,000",
      amount: "1000",
      image: "food-for-life-3.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 2,500",
      amount: "2500",
      image: "food-for-life-3.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 5,000",
      amount: "5000",
      image: "food-for-life-4.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 7,500",
      amount: "7500",
      image: "food-for-life-4.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 10,000",
      amount: "10000",
      image: "food-for-life-5.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 15,000",
      amount: "15000",
      image: "food-for-life-6.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 20,000",
      amount: "20000",
      image: "food-for-life-6.webp",
    },

    {
      title: "Your Nitya Seva",
      subtitle: "₹ 25,000",
      amount: "25000",
      image: "food-for-life-6.webp",
    },
    {
      title: "Your Nitya Seva",
      subtitle: "₹ 50,000",
      amount: "50000",
      image: "food-for-life-6.webp",
    },
  ];

  const [meta, setMeta] = useState(null);

  const fetchMeta = async (pagename) => {
    try {
      let res = await ApiService.fetchMetaData(pagename);
      setMeta(res);
    } catch (error) {
      console.log(error);
    }
  };

  const retryDonation = async () => {
    try {
      const res = await ApiService.retryDonation(donationId);
      console.log(res, "retry");

      setIsRetry(true);
      setRetryDonationDetails(res);
      setIsSadhuBhojanSeva(false);
      setIsBhagvadGita(false);
      setIsGoseva(false);
      setGoseva(0);
      setBhagavadGitaPrice(0);
      let addOns = {};
      for (let i = 0; i < res.donationAddOns.length; i++) {
        switch (res.donationAddOns[i].name) {
          case "sadhuBhojanSeva":
            addOns.sadhuBhojanSeva = res.donationAddOns[i].amount;
            setIsSadhuBhojanSeva(true);
            break;
          case "bhagavadGita":
            addOns.bhagavadGita = Number(res.donationAddOns[i].amount) / 200;
            setBhagavadGitaPrice(Number(res.donationAddOns[i].amount) / 200);
            setIsBhagvadGita(true);
            break;
          case "goseva":
            addOns.goseva = Number(res.donationAddOns[i].amount) / 120;
            setGoseva(Number(res.donationAddOns[i].amount) / 120);
            setIsGoseva(true);
            break;
        }
      }

      reset({
        ...res,
        ...addOns,
        donationType: res.type,
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchMeta("donation-form");
    if (donationId) {
      retryDonation();
    }
  }, [isRetry, donationId]);

  useEffect(() => {
    if (!user) {
      if (otpExp === 0) {
        setShowTimer(false);
        setShowResendLink(true);
        clearInterval(timer);
        setOtpExp(expiry);
      }
    }
  }, [otpExp, expiry, user]);

  const handleGetIcsData = async (id) => {
    const res = await ApiService.fetchDonorById(id);
    //console.log("DMS DATA --", res.donor)
    if (!donationId) {
      handelOptions();
    }
    setICSdata(res?.donor);
  };

  const getIcsData = async (e) => {
    const val = e.target.value.length;
    //console.log(e.target.value)
    try {
      if (val === 10) {
        const res = await ApiService.getIcsData(e.target.value);
        //console.log(res)
        setICSdatawl(res.data);
      } else {
        setICSdatawl("");
        setItemData("");
        setICSdata("");
        localStorage.setItem("ics_id", "");
        setIcsAddress("");
        setIcsPincode("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMonthYearRange = () => {
    const now = new Date();
    const startMonth = now
      .toLocaleString("en-US", { month: "short" })
      .toUpperCase();
    const startYear = now.getFullYear();

    const endDate = new Date(now);
    endDate.setMonth(endDate.getMonth() + 11); // full 12-month period
    const endMonth = endDate
      .toLocaleString("en-US", { month: "short" })
      .toUpperCase();
    const endYear = endDate.getFullYear();

    return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
  };

  const fetchNameFromIcs = async (e) => {
    const res = await ApiService.getIcsData(user.phone);

    let check_len = res.data
      .filter((dat) => dat.name.toUpperCase() === e.target.value.toUpperCase())
      .map((item) => item.pan);

    // console.log(check_len);
  };

  const { loginPopup, setLoginPopup } = useContext(AppContext);

  const campaignRef = useCallback((node) => {
    if (node) {
      let headerHeight;
      if (window.innerWidth > 991) {
        headerHeight = 121;
      } else if (window.innerWidth > 576) {
        headerHeight = 75;
      } else {
        headerHeight = 73;
      }
      setTop(node?.offsetTop - headerHeight);
    }
  });

  const handelOther = (e) => {
    setICSdata("");
    const currentValues = getValues();
    reset({
      ...currentValues,
      name: "",
      pan: "",
      address: "",
      pin: "",
      email: "",
    });
  };

  const handelOptions = (e) => {
    // TODO reset
    const currentValues = getValues();
    reset({
      name: user?.name,
      phone: user?.phone.trim(),
      email: user?.email,
      pan: user?.pan,
      address:
        user?.streetName && user?.areaName
          ? `${user?.streetName}, ${user?.areaName}`
          : user?.address,
      pin: user?.pin,
    });
    if (token) {
      handleGetIcsData(localStorage.getItem("ics_number"));
    }
  };

  //SELECT PROFILE IN NAME INPUT WHICH FLOW IN WEBSITE

  const handleSelectProfiles = (e) => {
    // console.log(ics_data)
    setItemData([]);
    setICSid(e.target.value);
    // console.log(e.target.value)
    const responseDataa = ics_data.filter((dat) => dat.id == e.target.value);
    // console.log(responseDataa)
    if (token) {
      setWithlogin(responseDataa[0].id);
      setIcsname(responseDataa[0].name);
    }
  };

  useEffect(() => {
    campaignRef();
    if (token && profiles?.length > 0) {
      handleGetIcsData(profiles[0]?.id);
    }
  }, [token, profiles]);

  const donationSteps = [
    {
      No: "01",
      title: "Choose your donation Amount",
      text: "Select an amount that feels meaningful to you, from ₹101 per month to any custom amount.",
      svg: (
        <svg
          width="25"
          height="33"
          viewBox="0 0 25 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.5279 9.81724C24.5279 10.5405 23.9361 11.1323 23.2128 11.1323H19.2282C18.8863 16.261 14.6123 20.3377 9.40468 20.3377H5.85401L17.466 29.8456C18.0315 30.3059 18.1104 31.1344 17.6501 31.6999C17.3871 32.0155 17.0057 32.1864 16.6244 32.1864C16.335 32.1864 16.0326 32.0944 15.7959 31.884L1.34335 20.0353C0.909383 19.6802 0.751576 19.1016 0.935685 18.5755C1.11979 18.0495 1.61952 17.7076 2.17184 17.7076H9.40468C13.1658 17.7076 16.2693 14.8145 16.5981 11.1323H2.17184C1.44856 11.1323 0.856781 10.5405 0.856781 9.81724C0.856781 9.09396 1.44856 8.50218 2.17184 8.50218H16.3613C15.4934 5.47754 12.7186 3.24194 9.40468 3.24194H2.17184C1.44856 3.24194 0.856781 2.65016 0.856781 1.92688C0.856781 1.20359 1.44856 0.611816 2.17184 0.611816H23.2128C23.9361 0.611816 24.5279 1.20359 24.5279 1.92688C24.5279 2.65016 23.9361 3.24194 23.2128 3.24194H16.0983C17.5844 4.62275 18.6364 6.45069 19.0572 8.50218H23.1997C23.9229 8.50218 24.5147 9.09396 24.5147 9.81724H24.5279Z"
            fill="white"
          />
        </svg>
      ), // replace with actual image URL
    },
    {
      No: "02",
      title: "Monthly Frequency",
      text: "Contributions will be automatically deducted every month for a duration of 12 months.",
      svg: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_92_538)">
            <path
              d="M23.0973 3.01323H21.8966V1.81252C21.8966 1.49408 21.7701 1.18867 21.5449 0.963496C21.3197 0.738319 21.0143 0.611816 20.6958 0.611816C20.3774 0.611816 20.072 0.738319 19.8468 0.963496C19.6216 1.18867 19.4951 1.49408 19.4951 1.81252V3.01323H9.88947V1.81252C9.88947 1.49408 9.76297 1.18867 9.5378 0.963496C9.31262 0.738319 9.00721 0.611816 8.68877 0.611816C8.37032 0.611816 8.06492 0.738319 7.83974 0.963496C7.61456 1.18867 7.48806 1.49408 7.48806 1.81252V3.01323H6.28735C4.6957 3.01514 3.16978 3.64826 2.04431 4.77373C0.918846 5.8992 0.28572 7.42512 0.283813 9.01677L0.283813 23.4253C0.28572 25.0169 0.918846 26.5428 2.04431 27.6683C3.16978 28.7938 4.6957 29.4269 6.28735 29.4288H23.0973C24.6889 29.4269 26.2148 28.7938 27.3403 27.6683C28.4658 26.5428 29.0989 25.0169 29.1008 23.4253V9.01677C29.0989 7.42512 28.4658 5.8992 27.3403 4.77373C26.2148 3.64826 24.6889 3.01514 23.0973 3.01323ZM2.68523 9.01677C2.68523 8.06143 3.06474 7.14521 3.74027 6.46968C4.4158 5.79416 5.33201 5.41465 6.28735 5.41465H23.0973C24.0526 5.41465 24.9688 5.79416 25.6443 6.46968C26.3199 7.14521 26.6994 8.06143 26.6994 9.01677V10.2175H2.68523V9.01677ZM23.0973 27.0274H6.28735C5.33201 27.0274 4.4158 26.6479 3.74027 25.9723C3.06474 25.2968 2.68523 24.3806 2.68523 23.4253V12.6189H26.6994V23.4253C26.6994 24.3806 26.3199 25.2968 25.6443 25.9723C24.9688 26.6479 24.0526 27.0274 23.0973 27.0274Z"
              fill="white"
            />
            <path
              d="M14.6923 20.4235C15.687 20.4235 16.4934 19.6172 16.4934 18.6225C16.4934 17.6278 15.687 16.8214 14.6923 16.8214C13.6976 16.8214 12.8912 17.6278 12.8912 18.6225C12.8912 19.6172 13.6976 20.4235 14.6923 20.4235Z"
              fill="white"
            />
            <path
              d="M8.68876 20.4235C9.68346 20.4235 10.4898 19.6172 10.4898 18.6225C10.4898 17.6278 9.68346 16.8214 8.68876 16.8214C7.69406 16.8214 6.8877 17.6278 6.8877 18.6225C6.8877 19.6172 7.69406 20.4235 8.68876 20.4235Z"
              fill="white"
            />
            <path
              d="M20.6958 20.4235C21.6905 20.4235 22.4969 19.6172 22.4969 18.6225C22.4969 17.6278 21.6905 16.8214 20.6958 16.8214C19.7011 16.8214 18.8948 17.6278 18.8948 18.6225C18.8948 19.6172 19.7011 20.4235 20.6958 20.4235Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_92_538">
              <rect
                width="28.817"
                height="28.817"
                fill="white"
                transform="translate(0.283813 0.611816)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      No: "03",
      title: "Set up your Payment Method",
      text: "Choose from multiple secure payment options including UPI, Credit/Debit Cards, or Net Banking.",
      svg: (
        <svg
          width="32"
          height="31"
          viewBox="0 0 32 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_92_550)">
            <path
              d="M7.82994 21.6236C8.87201 21.6236 9.71677 20.7789 9.71677 19.7368C9.71677 18.6947 8.87201 17.85 7.82994 17.85C6.78788 17.85 5.94312 18.6947 5.94312 19.7368C5.94312 20.7789 6.78788 21.6236 7.82994 21.6236Z"
              fill="white"
            />
            <path
              d="M24.8114 4.01331H7.20101C5.53357 4.0153 3.93499 4.67858 2.75593 5.85764C1.57686 7.0367 0.913588 8.63528 0.911591 10.3027L0.911591 20.3658C0.913588 22.0332 1.57686 23.6318 2.75593 24.8109C3.93499 25.99 5.53357 26.6532 7.20101 26.6552H24.8114C26.4788 26.6532 28.0774 25.99 29.2565 24.8109C30.4355 23.6318 31.0988 22.0332 31.1008 20.3658V10.3027C31.0988 8.63528 30.4355 7.0367 29.2565 5.85764C28.0774 4.67858 26.4788 4.0153 24.8114 4.01331ZM7.20101 6.52907H24.8114C25.8122 6.52907 26.7721 6.92665 27.4798 7.63435C28.1875 8.34205 28.585 9.30189 28.585 10.3027H3.42736C3.42736 9.30189 3.82494 8.34205 4.53264 7.63435C5.24033 6.92665 6.20018 6.52907 7.20101 6.52907ZM24.8114 24.1395H7.20101C6.20018 24.1395 5.24033 23.7419 4.53264 23.0342C3.82494 22.3265 3.42736 21.3666 3.42736 20.3658V12.8185H28.585V20.3658C28.585 21.3666 28.1875 22.3265 27.4798 23.0342C26.7721 23.7419 25.8122 24.1395 24.8114 24.1395Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_92_550">
              <rect
                width="30.1892"
                height="30.1892"
                fill="white"
                transform="translate(0.911591 0.239624)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      No: "04",
      title: "Make a Difference",
      text: "Your regular contribution creates lasting impact, and you’ll receive updates on the difference you’re making.",
      svg: (
        <svg
          width="37"
          height="37"
          viewBox="0 0 37 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.9893 18.0657C28.9893 17.5068 28.6756 16.9939 28.1761 16.7397C26.8977 16.0886 25.5285 15.4895 23.9944 14.9067C21.4582 13.9345 19.6104 12.0584 18.6501 9.48812C18.0748 7.92868 17.4831 6.54021 16.8424 5.2439C16.5911 4.73846 16.0738 4.41736 15.5104 4.41736C14.947 4.41736 14.4267 4.73846 14.1784 5.24539C13.5392 6.53724 12.949 7.92571 12.3737 9.48217C11.4133 12.0569 9.56403 13.933 7.03236 14.9038C5.48928 15.491 4.11865 16.0901 2.84464 16.7397C2.34663 16.9924 2.03296 17.5053 2.03296 18.0643C2.03296 18.6232 2.34663 19.1361 2.84612 19.3903C4.12756 20.0414 5.49671 20.642 7.0279 21.2218C9.56403 22.194 11.4119 24.0701 12.3722 26.6419C12.9505 28.2073 13.5407 29.5928 14.1784 30.8846C14.4296 31.3915 14.9455 31.7126 15.5104 31.7126C16.0753 31.7126 16.5926 31.3915 16.8424 30.8846C17.4831 29.5928 18.0733 28.2043 18.6471 26.6463C19.6089 24.0716 21.4597 22.1955 23.9884 21.2247C25.5255 20.642 26.8947 20.0429 28.1761 19.3918C28.6756 19.1376 28.9893 18.6262 28.9893 18.0657ZM22.9285 18.4478C19.6223 19.7159 17.1144 22.2579 15.8597 25.6132C15.7438 25.9283 15.6278 26.2346 15.5104 26.5348C15.3929 26.2346 15.277 25.9268 15.1581 25.6072C13.9093 22.2594 11.4015 19.7159 8.08784 18.4448C7.75485 18.32 7.43374 18.1921 7.11858 18.0657C7.43226 17.9379 7.75782 17.8115 8.09379 17.6837C11.4015 16.4141 13.9093 13.8721 15.1596 10.5198C15.277 10.2032 15.3944 9.89544 15.5104 9.59664C15.6278 9.89842 15.7453 10.2076 15.8627 10.5243C17.1144 13.8736 19.6223 16.4156 22.9329 17.6852C23.2659 17.81 23.5885 17.9379 23.9037 18.0657C23.587 18.1936 23.2615 18.32 22.9285 18.4478Z"
            fill="white"
          />
          <path
            d="M25.9596 10.5927C26.3387 10.7859 26.7118 10.945 27.079 11.0847C27.3867 11.2037 27.6023 11.4237 27.7182 11.7314C27.855 12.1075 28.0111 12.4821 28.1999 12.8657C28.4482 13.3741 28.9655 13.6982 29.5319 13.6982H29.5349C30.0998 13.6982 30.6171 13.3771 30.8668 12.8701C31.0556 12.4881 31.2102 12.112 31.3485 11.7388C31.4674 11.4237 31.683 11.2037 31.9848 11.0877C32.3579 10.9465 32.7295 10.7874 33.1086 10.5942C33.6081 10.3414 33.9218 9.82709 33.9218 9.26813C33.9218 8.70917 33.6066 8.1963 33.1071 7.94358C32.7295 7.7533 32.3579 7.59423 31.9892 7.453C31.683 7.33556 31.4674 7.11555 31.35 6.80336C31.2102 6.42726 31.0556 6.05115 30.8654 5.66761C30.6156 5.16217 30.0983 4.84106 29.5334 4.84106H29.5304C28.964 4.84106 28.4482 5.16365 28.1984 5.67207C28.0111 6.05412 27.855 6.43023 27.7197 6.7989C27.6008 7.11406 27.3852 7.33408 27.0835 7.45003C26.7089 7.59274 26.3372 7.75032 25.9581 7.94358C25.4586 8.1963 25.145 8.70917 25.145 9.26813C25.145 9.82709 25.4586 10.34 25.9581 10.5927H25.9596Z"
            fill="white"
          />
          <path
            d="M33.9233 26.4144C33.452 26.1751 32.9867 25.9759 32.5289 25.8034C32.0249 25.6102 31.6577 25.2356 31.4689 24.7271C31.295 24.2574 31.1003 23.7876 30.8654 23.3119C30.6141 22.805 30.0968 22.4839 29.5334 22.4839C28.967 22.4839 28.4497 22.8065 28.2014 23.3149C27.968 23.7906 27.7733 24.2589 27.6038 24.7197C27.4105 25.2356 27.0433 25.6102 26.5468 25.8005C26.083 25.9759 25.6162 26.1751 25.1465 26.4159C24.6484 26.6701 24.3348 27.1815 24.3348 27.7405C24.3348 28.2994 24.6484 28.8108 25.1465 29.065C25.6162 29.3044 26.08 29.5021 26.5424 29.679C27.0433 29.8708 27.4105 30.2439 27.6008 30.7538C27.7733 31.2221 27.968 31.6918 28.2029 32.1661C28.4526 32.673 28.9685 32.9941 29.5349 32.9956C30.0998 32.9956 30.6156 32.6759 30.8669 32.169C31.1032 31.6933 31.298 31.2236 31.4704 30.7582C31.6607 30.2439 32.0279 29.8708 32.5289 29.679C32.9927 29.5021 33.455 29.3058 33.9248 29.0665C34.4243 28.8123 34.7379 28.2994 34.7379 27.7405C34.7379 27.1815 34.4243 26.6686 33.9248 26.4144H33.9233Z"
            fill="white"
          />
        </svg>
      ),
    },
  ];

  const cardData = [
    {
      title: "Prasadam",
      description:
        "Receive the mercy of the Lord through sanctified prasadam sent directly to you with love and blessings from the temple.",
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 35 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.9231 8.13395V22.5228C34.9231 25.3761 33.812 28.0599 31.7936 30.077L27.5915 34.2793C27.4519 34.4189 27.2696 34.4872 27.0872 34.4872C26.9049 34.4872 26.7226 34.4174 26.583 34.2793C26.3052 34.0015 26.3052 33.5499 26.583 33.2721L30.7851 29.0699C32.5343 27.3206 33.4972 24.9958 33.4972 22.5228V8.13395C33.4972 6.95589 32.5386 5.9972 31.3605 5.9972C30.1825 5.9972 29.2239 6.95589 29.2239 8.13395C29.2239 8.13395 29.221 19.5941 29.2168 19.6254C29.1954 20.4046 28.9205 21.1795 28.392 21.8092L24.6343 25.7208C24.4947 25.8661 24.3081 25.9388 24.1215 25.9388C23.9435 25.9388 23.7654 25.8733 23.6273 25.7394C23.3438 25.4673 23.3352 25.0157 23.6073 24.7322L27.3337 20.8562C27.6442 20.4858 27.8009 20.0143 27.8009 19.5399C27.8009 19.5357 27.8009 19.5328 27.8009 19.5285V19.4744C27.7866 18.983 27.6057 18.4901 27.2567 18.0998C26.4733 17.2265 25.1243 17.151 24.2469 17.9345L20.3596 21.5129C19.6246 22.1881 19.0363 22.9844 18.6061 23.8818C19.0292 24.9545 19.2556 26.1069 19.2556 27.2793V33.7736C19.2556 34.1667 18.9366 34.4858 18.5434 34.4858C18.1503 34.4858 17.8312 34.1667 17.8312 33.7736V27.2793C17.8312 25.0941 16.9096 22.9929 15.3014 21.5143L11.407 17.9302C10.5395 17.1525 9.18911 17.2265 8.40424 18.1012C7.70057 18.8861 7.68205 20.0869 8.35866 20.8932L12.0522 24.7322C12.3243 25.0157 12.3158 25.4673 12.0323 25.7394C11.7474 26.0114 11.2973 26.0029 11.0252 25.7194L7.29887 21.8434C6.76471 21.208 6.48267 20.4402 6.44848 19.6696C6.43994 19.624 6.43424 8.1311 6.43424 8.1311C6.43424 6.95304 5.47559 5.99435 4.29758 5.99435C3.11956 5.99435 2.16091 6.95304 2.16091 8.1311V22.52C2.16091 24.9929 3.12384 27.3191 4.87305 29.067L9.07515 33.2693C9.35292 33.5471 9.35292 33.9986 9.07515 34.2764C8.93556 34.416 8.75323 34.4844 8.5709 34.4844C8.38857 34.4844 8.20624 34.4146 8.06665 34.2764L3.86455 30.0741C1.84611 28.0556 0.735046 25.3733 0.735046 22.52V8.13395C0.735046 6.17099 2.33327 4.5727 4.29615 4.5727C6.25903 4.5727 7.85726 6.17099 7.85726 8.13395V16.6781C9.18626 15.6824 11.0793 15.7265 12.3613 16.8747L16.2629 20.4659C16.8697 21.0243 17.3939 21.6596 17.8269 22.3476C18.2614 21.6567 18.7856 21.0271 19.3938 20.4659L23.2882 16.8818C24.5759 15.728 26.4704 15.6824 27.7994 16.6781V8.13395C27.7994 6.17099 29.3977 4.5727 31.3605 4.5727C33.3234 4.5727 34.9231 6.17099 34.9231 8.13395ZM10.7076 4.47298C10.7076 2.17099 12.4639 0.299194 14.6248 0.299194C15.9951 0.299194 17.1389 0.890362 17.8298 1.8519C18.5206 0.890362 19.6645 0.299194 21.0348 0.299194C23.1957 0.299194 24.952 2.17099 24.952 4.47298C24.952 7.4858 21.3211 11.1795 19.4024 12.7109C18.9394 13.0798 18.3853 13.2636 17.8298 13.2636C17.2742 13.2636 16.7216 13.0798 16.2586 12.7109C14.3385 11.1795 10.7076 7.48723 10.7076 4.47298ZM12.132 4.47298C12.132 6.62683 15.0649 9.93595 17.1475 11.5955C17.5492 11.9174 18.1118 11.9174 18.5135 11.5955C20.5946 9.93452 23.5275 6.62683 23.5275 4.47298C23.5275 2.95731 22.4094 1.7237 21.0348 1.7237C19.5676 1.7237 18.542 2.72512 18.542 4.15817C18.542 4.55133 18.2229 4.87042 17.8298 4.87042C17.4366 4.87042 17.1176 4.55133 17.1176 4.15817C17.1176 2.72512 16.092 1.7237 14.6248 1.7237C13.2502 1.7237 12.132 2.95731 12.132 4.47298Z"
            fill="#FFC84F"
          />
        </svg>
      ),
    },
    {
      title: "Special Birthday Puja",
      description:
        "A puja will be offered on your birthday in your name, praying for your well-being and blessings from Sri Sri Radha Madhava.",
      svg: (
        <svg
          width="31"
          height="32"
          viewBox="0 0 31 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.0025 10.6273C27.8718 10.6273 30.2052 8.31119 30.2052 5.46323C30.2052 2.61526 27.8718 0.299194 25.0025 0.299194C22.1333 0.299194 19.7999 2.61526 19.7999 5.46323C19.7999 8.31119 22.1333 10.6273 25.0025 10.6273ZM25.0025 1.5902C27.1538 1.5902 28.9045 3.3279 28.9045 5.46323C28.9045 7.59856 27.1538 9.33625 25.0025 9.33625C22.8512 9.33625 21.1005 7.59856 21.1005 5.46323C21.1005 3.3279 22.8512 1.5902 25.0025 1.5902ZM27.5869 16.7286L26.7168 13.0156C26.2967 13.1099 25.8636 13.1654 25.4213 13.1886L26.3188 17.0203L27.5531 22.2941C27.6884 22.9164 27.5427 23.5619 27.1577 24.0615C26.7779 24.5482 26.216 24.8284 25.6164 24.8284H3.5767C2.97709 24.8284 2.41521 24.5482 2.03801 24.0615C1.65172 23.5606 1.50604 22.9164 1.63611 22.3057L4.53789 9.91462C5.59142 5.01267 9.72753 1.5902 14.5972 1.5902C15.7691 1.5902 16.8968 1.79289 17.9503 2.16212C18.1402 1.7632 18.36 1.38235 18.6124 1.02474C17.3572 0.556105 16.0058 0.299194 14.5972 0.299194C9.10842 0.299194 4.44814 4.14253 3.26974 9.63318L0.367961 22.0243C0.154652 23.0184 0.387471 24.046 1.00789 24.849C1.63481 25.6559 2.57259 26.1181 3.578 26.1181H8.22657C8.83138 29.0603 11.4574 31.2821 14.5985 31.2821C17.7396 31.2821 20.3657 29.0603 20.9705 26.1181H25.6203C26.6245 26.1181 27.5609 25.6559 28.1931 24.8477C28.8109 24.0447 29.0424 23.0158 28.8265 22.0127L27.5895 16.7273L27.5869 16.7286ZM14.5972 29.9924C12.1806 29.9924 10.1607 28.3412 9.57926 26.1194H19.6152C19.0338 28.3412 17.0152 29.9924 14.5972 29.9924Z"
            fill="#FFC84F"
          />
        </svg>
      ),
    },
    {
      title: "Gifts and a Calendar",
      description:
        "As a token of thanks, you’ll receive devotional gifts and a beautiful yearly calendar featuring Sri Sri Radha Madhava, along with festival and Ekadashi dates.",
      svg: (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.3766 10.2878L15.8752 15.873C15.322 16.4264 14.5955 16.7044 13.8691 16.7044C13.1426 16.7044 12.4199 16.4289 11.8679 15.8768L8.84989 12.7794C8.6094 12.5326 8.61438 12.1375 8.8611 11.8982C9.10782 11.6588 9.50283 11.6626 9.74207 11.9094L12.7538 15.0018C13.3669 15.6138 14.3725 15.615 14.9905 14.9968L20.4882 9.41404C20.7287 9.16849 21.1237 9.16475 21.3692 9.4078C21.6146 9.64836 21.6171 10.0435 21.3754 10.289L21.3766 10.2878ZM30.1278 25.4792C29.8213 26.2196 29.1334 26.6795 28.331 26.6795H26.5379V28.4681C26.5379 29.2708 26.0768 29.9601 25.3367 30.2655C25.0887 30.3689 24.8332 30.4188 24.5815 30.4188C24.0806 30.4188 23.5946 30.2206 23.2171 29.8417L17.8627 24.4758C17.6571 24.6478 17.4465 24.8161 17.2023 24.9507C16.6191 25.2736 15.965 25.4356 15.3108 25.4356C14.6566 25.4356 14.0024 25.2736 13.4192 24.9507C13.1812 24.8186 12.9769 24.6541 12.775 24.4871L7.43186 29.8417C7.05555 30.2206 6.56958 30.4188 6.06741 30.4188C5.8157 30.4188 5.56026 30.3689 5.31229 30.2667C4.57088 29.9601 4.10983 29.2708 4.10983 28.4681V26.6795H2.31674C1.51551 26.6795 0.827682 26.2196 0.521149 25.4792C0.213369 24.7388 0.375359 23.9262 0.942321 23.359L5.36587 18.9342C5.36712 18.6463 5.38332 18.3596 5.44687 18.0779C5.5964 17.4223 5.29609 16.7231 4.69923 16.3379C4.13974 15.9777 3.68617 15.4866 3.34848 14.8784C3.03074 14.3038 2.86501 13.6432 2.86875 12.9663C2.86501 12.297 3.03074 11.6377 3.34848 11.0631C3.68617 10.4536 4.14099 9.96246 4.69923 9.60225C5.29609 9.2171 5.5964 8.51786 5.44687 7.86224C5.29609 7.19664 5.31852 6.5136 5.5154 5.83056C5.88299 4.54924 6.90851 3.52343 8.19072 3.15573C8.87356 2.96004 9.55516 2.93761 10.2193 3.08718C10.8735 3.238 11.5738 2.93511 11.9601 2.33932C12.3202 1.78092 12.8111 1.32723 13.4192 0.989444C14.588 0.342549 16.036 0.342549 17.2035 0.989444C17.8116 1.32723 18.3026 1.78092 18.6627 2.33932C19.0477 2.93636 19.7493 3.23675 20.4035 3.08718C21.0664 2.93636 21.7492 2.9588 22.4308 3.15573C23.713 3.52343 24.7385 4.54924 25.1061 5.83056C25.303 6.5136 25.3254 7.19664 25.1747 7.86099C25.0251 8.51661 25.3254 9.21585 25.9223 9.601C26.4818 9.96122 26.9354 10.4523 27.273 11.0606C27.5908 11.6339 27.7565 12.2945 27.754 12.9701C27.7565 13.6419 27.5908 14.3013 27.273 14.8746C26.9354 15.4841 26.4805 15.9752 25.9223 16.3354C25.3254 16.7206 25.0251 17.4198 25.1747 18.0754C25.2357 18.3472 25.2494 18.6239 25.2532 18.9006L29.7079 23.3566C30.2748 23.9237 30.4356 24.7351 30.129 25.4767L30.1278 25.4792ZM11.9302 23.5684C11.5414 22.9963 10.8561 22.7059 10.2168 22.8517C9.55392 23.0026 8.87107 22.9801 8.18947 22.7832C7.01442 22.4467 6.08236 21.5455 5.64624 20.4137L1.8208 24.2403C1.51427 24.5469 1.62766 24.9009 1.66878 25.0018C1.71115 25.1028 1.88061 25.4331 2.31425 25.4331H4.73038C5.07429 25.4331 5.35341 25.7123 5.35341 26.0563V28.4681C5.35341 28.9019 5.68362 29.0727 5.7858 29.115C5.88673 29.1562 6.24061 29.2696 6.54715 28.9617L11.9302 23.5684ZM17.6135 22.924C18.2826 21.8883 19.5138 21.3747 20.6763 21.6365C21.1337 21.7412 21.6084 21.7225 22.0857 21.5866C22.9454 21.3398 23.6607 20.6256 23.9062 19.7656C24.0432 19.2857 24.0607 18.8108 23.9573 18.3546C23.6931 17.1892 24.2102 15.959 25.2444 15.2909C25.6295 15.0429 25.9447 14.7001 26.1802 14.2726C26.3946 13.885 26.5067 13.4363 26.5055 12.9726C26.5067 12.5039 26.3958 12.0552 26.1802 11.6676C25.9435 11.2413 25.6282 10.8985 25.2444 10.6505C24.209 9.98241 23.6918 8.75094 23.9573 7.58678C24.0607 7.12934 24.0445 6.65445 23.9062 6.17582C23.6594 5.31579 22.9454 4.60034 22.0857 4.35479C21.6084 4.21769 21.1349 4.19899 20.6763 4.30494C19.5163 4.56544 18.2814 4.05191 17.6135 3.01738C17.3655 2.63223 17.0229 2.31689 16.5967 2.08131C15.8154 1.64631 14.8036 1.64756 14.0223 2.08131C13.5962 2.31689 13.2535 2.63223 13.0068 3.01738C12.3376 4.05316 11.1065 4.56669 9.94394 4.30494C9.48663 4.20024 9.01188 4.21769 8.53463 4.35479C7.67484 4.60159 6.9596 5.31579 6.71412 6.17582C6.57705 6.65569 6.55961 7.13058 6.66303 7.58678C6.9272 8.75218 6.41008 9.98241 5.37584 10.6505C4.99081 10.8985 4.67555 11.2413 4.44004 11.6688C4.22572 12.0565 4.11357 12.5052 4.11606 12.9676C4.11357 13.4375 4.22572 13.8875 4.44004 14.2751C4.6768 14.7014 4.99205 15.0441 5.37584 15.2922C6.41133 15.9603 6.92845 17.1917 6.66303 18.3559C6.55961 18.8133 6.57705 19.2882 6.71412 19.7668C6.96084 20.6269 7.67484 21.3423 8.53463 21.5879C9.01188 21.7237 9.48538 21.7437 9.94394 21.6377C10.147 21.5916 10.3514 21.5692 10.5558 21.5692C11.5202 21.5692 12.456 22.0702 13.008 22.924C13.256 23.3092 13.5987 23.6245 14.0248 23.8601C14.8049 24.2951 15.8167 24.2939 16.5992 23.8601C17.0266 23.6233 17.368 23.3079 17.616 22.924H17.6135ZM28.8257 24.2403L24.9815 20.395C24.5504 21.5368 23.6121 22.4454 22.4296 22.7844C21.748 22.9801 21.0651 23.0026 20.401 22.853C19.763 22.7059 19.0926 22.9926 18.7013 23.5535L24.0981 28.9617C24.4058 29.2696 24.7585 29.1562 24.8594 29.115C24.9616 29.0727 25.2918 28.9031 25.2918 28.4681V26.0563C25.2918 25.7123 25.5709 25.4331 25.9148 25.4331H28.331C28.7646 25.4331 28.9341 25.1028 28.9764 25.0018C29.0188 24.9009 29.1334 24.5469 28.8257 24.2403Z"
            fill="#FFC84F"
          />
        </svg>
      ),
    },
    {
      title: "Regular Updates",
      description:
        "We’ll keep you informed with newsletters and photos so you can see how your seva is helping.",
      svg: (
        <svg
          width="30"
          height="31"
          viewBox="0 0 30 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4722 15.2051C14.5775 15.2051 17.9161 11.8509 17.9161 7.72644C17.9161 3.60197 14.5775 0.247803 10.4722 0.247803C6.3669 0.247803 3.0283 3.60197 3.0283 7.72644C3.0283 11.8509 6.3669 15.2051 10.4722 15.2051ZM10.4722 1.49424C13.8927 1.49424 16.6755 4.29 16.6755 7.72644C16.6755 11.1629 13.8927 13.9586 10.4722 13.9586C7.05174 13.9586 4.26895 11.1629 4.26895 7.72644C4.26895 4.29 7.05174 1.49424 10.4722 1.49424ZM11.7129 18.3212C11.7129 18.6652 11.435 18.9444 11.0925 18.9444C5.9612 18.9444 1.78765 23.1374 1.78765 28.2927V29.5391C1.78765 29.8831 1.50974 30.1623 1.16732 30.1623C0.824903 30.1623 0.546997 29.8831 0.546997 29.5391V28.2927C0.546997 22.4506 5.2776 17.6979 11.0925 17.6979C11.435 17.6979 11.7129 17.9771 11.7129 18.3212ZM21.6381 18.9444C20.2696 18.9444 19.1568 20.0624 19.1568 21.4373C19.1568 22.8121 20.2696 23.9301 21.6381 23.9301C23.0065 23.9301 24.1194 22.8121 24.1194 21.4373C24.1194 20.0624 23.0065 18.9444 21.6381 18.9444ZM21.6381 22.6837C20.9545 22.6837 20.3974 22.124 20.3974 21.4373C20.3974 20.7505 20.9545 20.1908 21.6381 20.1908C22.3217 20.1908 22.8787 20.7505 22.8787 21.4373C22.8787 22.124 22.3217 22.6837 21.6381 22.6837ZM28.4691 23.2795L27.6677 22.8096C27.7843 22.3297 27.8413 21.8785 27.8413 21.4385C27.8413 20.9985 27.7843 20.5473 27.6677 20.0662L28.4691 19.5963C28.8984 19.3445 29.2048 18.9394 29.3314 18.4558C29.4579 17.9722 29.3884 17.4686 29.1378 17.0386C28.8872 16.6073 28.4852 16.2994 28.0039 16.1723C27.5213 16.0452 27.0213 16.1137 26.592 16.3655L25.7967 16.8317C25.1305 16.2234 24.3489 15.7697 23.4978 15.5005V14.5806C23.4978 13.5498 22.6629 12.7109 21.6368 12.7109C20.6108 12.7109 19.7759 13.5498 19.7759 14.5806V15.5005C18.9235 15.7697 18.1432 16.2234 17.4769 16.8317L16.6817 16.3655C16.2524 16.1137 15.7512 16.0452 15.2698 16.1723C14.7897 16.2994 14.3865 16.6073 14.1359 17.0373C13.8852 17.4686 13.817 17.9722 13.9423 18.4545C14.0676 18.9369 14.3753 19.3432 14.8046 19.595L15.606 20.0649C15.4894 20.5448 15.4323 20.9973 15.4323 21.4373C15.4323 21.8773 15.4894 22.3285 15.606 22.8083L14.8046 23.2782C14.3753 23.53 14.0689 23.9351 13.9423 24.4187C13.8158 24.9024 13.8852 25.4059 14.1359 25.8359C14.3865 26.2672 14.7884 26.5751 15.2698 26.7022C15.7512 26.8294 16.2524 26.7608 16.6804 26.5078L17.4757 26.0416C18.1419 26.6511 18.9235 27.1036 19.7746 27.3728V28.2927C19.7746 29.3235 20.6096 30.1623 21.6356 30.1623C22.6616 30.1623 23.4966 29.3235 23.4966 28.2927V27.3728C24.3489 27.1023 25.1293 26.6499 25.7955 26.0416L26.5895 26.5078C27.0188 26.7608 27.52 26.8281 28.0014 26.7022C28.4828 26.5751 28.8847 26.2672 29.1353 25.8372C29.386 25.4059 29.4542 24.9024 29.3289 24.42C29.2036 23.9376 28.8959 23.5313 28.4666 23.2795H28.4691ZM28.0671 25.2077C27.984 25.3511 27.8488 25.4545 27.6887 25.4957C27.5287 25.538 27.3612 25.5144 27.2185 25.4309L26.0139 24.7241C25.7645 24.577 25.4469 24.6232 25.2484 24.8363C24.5673 25.5667 23.6988 26.069 22.741 26.2884C22.4582 26.3532 22.2584 26.605 22.2584 26.8954V28.2914C22.2584 28.6354 21.9805 28.9146 21.6381 28.9146C21.2957 28.9146 21.0178 28.6354 21.0178 28.2914V26.8954C21.0178 26.605 20.818 26.352 20.5351 26.2884C19.5761 26.069 18.7089 25.5667 18.0278 24.8363C17.9074 24.7067 17.7424 24.6394 17.5749 24.6394C17.4683 24.6394 17.3603 24.6668 17.2623 24.7241L16.0576 25.4309C15.915 25.5144 15.7475 25.538 15.5874 25.4957C15.4274 25.4533 15.2934 25.3511 15.209 25.2065C15.1259 25.0632 15.1023 24.8949 15.1445 24.7353C15.1867 24.5745 15.2884 24.4387 15.4311 24.3552L16.6457 23.6422C16.8963 23.4951 17.0117 23.1947 16.9248 22.9168C16.7536 22.3696 16.6742 21.8984 16.6742 21.436C16.6742 20.9736 16.7536 20.5037 16.9248 19.9552C17.0117 19.6773 16.8963 19.3769 16.6457 19.2311L15.4311 18.5193C15.2884 18.4358 15.1855 18.3 15.1445 18.1392C15.1023 17.9784 15.1247 17.8114 15.209 17.6668C15.2921 17.5234 15.4274 17.42 15.5874 17.3789C15.7462 17.3352 15.9137 17.3577 16.0576 17.4424L17.2623 18.1492C17.5117 18.295 17.8305 18.2501 18.0278 18.0382C18.7089 17.3078 19.5774 16.8055 20.5351 16.5861C20.818 16.5213 21.0178 16.2695 21.0178 15.9791V14.5831C21.0178 14.2391 21.2957 13.9599 21.6381 13.9599C21.9805 13.9599 22.2584 14.2391 22.2584 14.5831V15.9791C22.2584 16.2695 22.4582 16.5226 22.741 16.5861C23.7 16.8055 24.5673 17.3078 25.2484 18.0382C25.4469 18.2501 25.7645 18.2962 26.0139 18.1492L27.2185 17.4424C27.3612 17.3577 27.5287 17.3352 27.6887 17.3789C27.8488 17.4212 27.9828 17.5234 28.0671 17.668C28.1503 17.8114 28.1738 17.9796 28.1317 18.1392C28.0895 18.3 27.9877 18.4358 27.8451 18.5193L26.6305 19.2311C26.3799 19.3769 26.2645 19.6773 26.3513 19.9552C26.5225 20.5037 26.6019 20.9748 26.6019 21.436C26.6019 21.8972 26.5225 22.3684 26.3513 22.9168C26.2645 23.1947 26.3799 23.4951 26.6305 23.6422L27.8451 24.3552C27.9877 24.4387 28.0907 24.5745 28.1317 24.7353C28.1738 24.8961 28.1515 25.0632 28.0671 25.2077Z"
            fill="#FFC84F"
          />
        </svg>
      ),

      styleClass: "custom-margin-left", // Instead of inline style
    },
    {
      title: "Tax Benefits",
      description:
        "All donations are eligible for tax deductions under Section 80G of the Income Tax Act.",
      svg: (
        <svg
          width="34"
          height="33"
          viewBox="0 0 34 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.75664 12.4276L15.771 0.408881C15.9753 0.101736 16.3894 0.0189404 16.6966 0.223259C17.0038 0.427577 17.0867 0.841556 16.8823 1.1487L8.86796 13.1674C8.73973 13.3611 8.52735 13.4652 8.31096 13.4652C8.18407 13.4652 8.05584 13.4292 7.94097 13.3531C7.63375 13.1487 7.55227 12.7348 7.75664 12.4276ZM16.3266 8.12357C17.7999 8.12357 18.9981 9.32144 18.9981 10.7944C18.9981 12.2674 17.7999 13.4652 16.3266 13.4652C14.8533 13.4652 13.6552 12.2674 13.6552 10.7944C13.6552 9.32144 14.8533 8.12357 16.3266 8.12357ZM16.3266 9.45898C15.5907 9.45898 14.9909 10.0586 14.9909 10.7944C14.9909 11.5302 15.5907 12.1298 16.3266 12.1298C17.0626 12.1298 17.6624 11.5302 17.6624 10.7944C17.6624 10.0586 17.0626 9.45898 16.3266 9.45898ZM5.64085 2.78191C5.64085 1.30895 6.83899 0.111084 8.3123 0.111084C9.7856 0.111084 10.9837 1.30895 10.9837 2.78191C10.9837 4.25488 9.7856 5.45274 8.3123 5.45274C6.83899 5.45274 5.64085 4.25488 5.64085 2.78191ZM6.97657 2.78191C6.97657 3.51773 7.57631 4.11733 8.3123 4.11733C9.04828 4.11733 9.64802 3.51773 9.64802 2.78191C9.64802 2.0461 9.04828 1.4465 8.3123 1.4465C7.57631 1.4465 6.97657 2.0461 6.97657 2.78191ZM32.1737 17.7132L23.0827 27.9144C20.6771 30.6133 17.2229 32.1624 13.6084 32.1624H5.64085C3.06291 32.1624 0.96582 30.0658 0.96582 27.4884V20.8113C0.96582 18.234 3.06291 16.1374 5.64085 16.1374H18.8084C20.422 16.1374 21.7857 17.2244 22.2038 18.7041L27.1887 13.2262C27.7911 12.5638 28.6166 12.1752 29.5116 12.1338C30.4012 12.0991 31.264 12.4022 31.9279 13.0045C33.2783 14.2358 33.3878 16.3484 32.1737 17.7132ZM31.0289 13.9914C30.6309 13.6281 30.1086 13.4492 29.5757 13.4666C29.0374 13.4919 28.5405 13.7256 28.1772 14.1236L22.1731 20.7205C21.771 21.9825 20.6717 22.9614 19.3066 23.1563L11.0626 24.1432C10.6845 24.1886 10.364 23.9242 10.3199 23.5596C10.2758 23.1937 10.5376 22.8612 10.9036 22.8171L19.133 21.8329C20.1909 21.682 21.0017 20.7486 21.0017 19.6642C21.0017 18.4557 20.0172 17.4715 18.8084 17.4715H5.64085C3.80022 17.4715 2.30154 18.9698 2.30154 20.81V27.4871C2.30154 29.3273 3.80022 30.8256 5.64085 30.8256H13.6084C16.8436 30.8256 19.9331 29.4408 22.0849 27.025L31.1759 16.8238C31.9078 16.0025 31.8411 14.7312 31.0289 13.99V13.9914Z"
            fill="#FFC84F"
          />
        </svg>
      ),
    },
  ];

  const testimonials = [
    {
      text: "Nitya Seva has transformed my giving from sporadic to consistent. I love that I can contribute regularly to causes I care about without having to think about it each time.",
      name: "Priya Mehta",
      city: "Mumbai",
      image: "../images/common/default-pro.png", // Replace with actual image
    },
    {
      text: "Nitya Seva has transformed my giving from sporadic to consistent. I love that I can contribute regularly to causes I care about without having to think about it each time.",
      name: "Priya Mehta",
      city: "Mumbai",
      image: "../images/common/default-pro.png", // Replace with actual image
    },
    {
      text: "Nitya Seva has transformed my giving from sporadic to consistent. I love that I can contribute regularly to causes I care about without having to think about it each time.",
      name: "Priya Mehta",
      city: "Mumbai",
      image: "../images/common/default-pro.png", // Replace with actual image
    },
  ];

  return (
    <>
      <MetaData title="Nitya Seva - ISKCON of Bhiwandi" />
      <PageHeader
        title="Nitya Seva form"
        imgSrc="/images/page-header/17.webp"
      />
      <section
        className="donation-form-sec"
        ref={(node) => {
          formRef.current = node;
          campaignRef(node);
        }}
      >
        <div className="container">
          <div
            className="row d-flex justify-content-center mb-5"
            id="scrollToDonateFrom"
          >
            <div className="col-md-12">
              {/* <figure className="mb-0">
                <img
                  className="w-100"
                  src="/images/page-header/nitya-seva-bvanner.jpg"
                  alt="Nitya Seva image"
                />
              </figure> */}
              <div id="scrollToDonationForm" className="nitya-seva-heading">
                <h2 className="head-1 mt-3" style={{}}>
                  OFFER A LITTLE EACH MONTH
                </h2>

                <p
                  style={{
                    textAlign: "justify",
                  }}
                >
                  Every time a lamp is lit or a meal is served, your presence is
                  felt. Your monthly offering supports the daily worship of Sri
                  Sri Radha Madhava and helps serve sanctified meals to many.
                </p>
                <p style={{ textAlign: "left" }}>
                  Support us in our mission of devotion and service by joining
                  Nitya Seva today.
                </p>
              </div>
            </div>
          </div>

          {!shownForm ? (
            <div className="monthly-seva-container">
              <div>
                <div className="section-title">Choose Nitya Seva</div>
                <div className="button-group">
                  {sevaOptions?.map((seva) => (
                    <button
                      key={seva}
                      onClick={() => setSelectedSeva(seva)}
                      className={`option-button ${
                        selectedSeva === seva ? "active" : ""
                      }`}
                    >
                      {seva}
                    </button>
                  ))}
                </div>
              </div>
              {isMobile && (
                <svg
                  width="347"
                  height="2"
                  viewBox="0 0 347 2"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L346 1.00003"
                    stroke="#9AA8B9"
                    stroke-opacity="0.41"
                    stroke-linecap="round"
                  />
                </svg>
              )}
              <div>
                <div className="section-title">Choose monthly amount</div>
                <div className="button-group">
                  {amountOptions.map((amount) =>
                    amount !== 2500 ? (
                      <button
                        key={amount}
                        onClick={() => {
                          setSelectedAmount(amount);
                          setShowDropdown(false);
                        }}
                        className={`amount-button ${
                          selectedAmount === amount ? "active" : ""
                        }`}
                      >
                        <span className="currency-symbol">₹</span>
                        <span className="currency-amount">
                          {amount.toLocaleString("en-IN")}
                        </span>
                      </button>
                    ) : (
                      <div
                        key="dropdown"
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        <button
                          onClick={() => setShowDropdown(!showDropdown)}
                          className={`amountss-button ${
                            dropdownAmounts.includes(selectedAmount)
                              ? "active"
                              : ""
                          }`}
                        >
                          ₹{" "}
                          {dropdownAmounts.includes(selectedAmount)
                            ? selectedAmount.toLocaleString("en-IN")
                            : "2,500"}{" "}
                          <svg
                            width="12"
                            height="6"
                            viewBox="0 0 12 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.7508 0.247421C11.6711 0.169022 11.5763 0.106794 11.4719 0.0643287C11.3674 0.0218632 11.2554 0 11.1423 0C11.0291 0 10.9171 0.0218632 10.8127 0.0643287C10.7082 0.106794 10.6134 0.169022 10.5338 0.247421L6.6085 4.07837C6.52883 4.15677 6.43404 4.219 6.3296 4.26146C6.22516 4.30393 6.11314 4.32579 6 4.32579C5.88686 4.32579 5.77484 4.30393 5.6704 4.26146C5.56596 4.219 5.47117 4.15677 5.3915 4.07837L1.46623 0.247421C1.38655 0.169022 1.29176 0.106794 1.18732 0.0643287C1.08289 0.0218632 0.970865 0 0.857725 0C0.744585 0 0.632564 0.0218632 0.528125 0.0643287C0.423686 0.106794 0.328896 0.169022 0.249222 0.247421C0.0895969 0.404141 0 0.616141 0 0.837119C0 1.0581 0.0895969 1.2701 0.249222 1.42682L4.18306 5.26613C4.66515 5.73605 5.31865 6 6 6C6.68135 6 7.33485 5.73605 7.81694 5.26613L11.7508 1.42682C11.9104 1.2701 12 1.0581 12 0.837119C12 0.616141 11.9104 0.404141 11.7508 0.247421Z"
                              fill="#758497"
                            />
                          </svg>
                        </button>

                        {showDropdown && (
                          <div
                            className="dropdown-menu show"
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              zIndex: 1000,
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "5px 0",
                            }}
                          >
                            {dropdownAmounts.map((amt) => (
                              <div
                                key={amt}
                                onClick={() => {
                                  setSelectedAmount(amt);
                                  setShowDropdown(false);
                                }}
                                className="dropdown-item"
                                style={{
                                  padding: "8px 16px",
                                  cursor: "pointer",
                                  backgroundColor:
                                    selectedAmount === amt
                                      ? "#f0f0f0"
                                      : "transparent",
                                }}
                              >
                                ₹ {amt.toLocaleString("en-IN")}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )
                  )}
                </div>
              </div>

              <div className="cta-container">
                <div className="caption">
                  Begin your journey with love – Krishna is waiting for your
                  first step.
                </div>
                <button
                  className="cta-button"
                  onClick={() => setShownForm(true)}
                >
                  START MY MONTHLY SEVA
                </button>
              </div>
            </div>
          ) : (
            <div
              className="form-wrap my-5"
              style={{
                scrollMarginBlockStart: "150px",
                backgroundColor: "#F7F7F7",
              }}
            >
              <form onSubmit={handleSubmit(handleNityaSevaSub)}>
                <div className="row align-items-start">
                  <div className="col-lg-8 mt-lg-0 mt-4">
                    <div className="row">
                      <div
                        className="monthly-seva-container"
                        style={{ backgroundColor: "transparent" }}
                      >
                        <div>
                          <div className="section-title">Choose Nitya Seva</div>
                          <div className="button-group">
                            {sevaOptions.map((seva) => (
                              <button
                                key={seva}
                                type="button"
                                onClick={() => {
                                  setSelectedSeva(seva);
                                  setValue("schemaname", seva); // update form value
                                }}
                                className={`option-button ${
                                  selectedSeva === seva ? "active" : ""
                                }`}
                              >
                                {seva}
                              </button>
                            ))}
                          </div>
                          {errors.schemaname?.message && (
                            <small className="text-danger error">
                              {errors.schemaname.message}
                            </small>
                          )}
                        </div>
                        {isMobile && (
                          <svg
                            width="347"
                            height="2"
                            viewBox="0 0 347 2"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L346 1.00003"
                              stroke="#9AA8B9"
                              stroke-opacity="0.41"
                              stroke-linecap="round"
                            />
                          </svg>
                        )}
                        <div>
                          <div className="section-title">
                            Choose monthly amount
                          </div>
                          <div className="button-group">
                            {amountOptions.map((amount) =>
                              amount !== 2500 ? (
                                <button
                                  key={amount}
                                  onClick={() => {
                                    setSelectedAmount(amount);
                                    setShowDropdown(false);
                                  }}
                                  className={`amount-button ${
                                    selectedAmount === amount ? "active" : ""
                                  }`}
                                >
                                  <span className="currency-symbol">₹</span>
                                  <span className="currency-amount">
                                    {amount.toLocaleString("en-IN")}
                                  </span>
                                </button>
                              ) : (
                                <div
                                  key="dropdown"
                                  style={{
                                    position: "relative",
                                    display: "inline-block",
                                    width: "100%",
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      setShowDropdown(!showDropdown)
                                    }
                                    className={`amountss-button ${
                                      dropdownAmounts.includes(selectedAmount)
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    ₹{" "}
                                    {dropdownAmounts.includes(selectedAmount)
                                      ? selectedAmount.toLocaleString("en-IN")
                                      : "2,500"}{" "}
                                    <svg
                                      width="12"
                                      height="6"
                                      viewBox="0 0 12 6"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.7508 0.247421C11.6711 0.169022 11.5763 0.106794 11.4719 0.0643287C11.3674 0.0218632 11.2554 0 11.1423 0C11.0291 0 10.9171 0.0218632 10.8127 0.0643287C10.7082 0.106794 10.6134 0.169022 10.5338 0.247421L6.6085 4.07837C6.52883 4.15677 6.43404 4.219 6.3296 4.26146C6.22516 4.30393 6.11314 4.32579 6 4.32579C5.88686 4.32579 5.77484 4.30393 5.6704 4.26146C5.56596 4.219 5.47117 4.15677 5.3915 4.07837L1.46623 0.247421C1.38655 0.169022 1.29176 0.106794 1.18732 0.0643287C1.08289 0.0218632 0.970865 0 0.857725 0C0.744585 0 0.632564 0.0218632 0.528125 0.0643287C0.423686 0.106794 0.328896 0.169022 0.249222 0.247421C0.0895969 0.404141 0 0.616141 0 0.837119C0 1.0581 0.0895969 1.2701 0.249222 1.42682L4.18306 5.26613C4.66515 5.73605 5.31865 6 6 6C6.68135 6 7.33485 5.73605 7.81694 5.26613L11.7508 1.42682C11.9104 1.2701 12 1.0581 12 0.837119C12 0.616141 11.9104 0.404141 11.7508 0.247421Z"
                                        fill="#758497"
                                      />
                                    </svg>
                                  </button>

                                  {showDropdown && (
                                    <div
                                      className="dropdown-menu show"
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        zIndex: 1000,
                                        backgroundColor: "#fff",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "5px 0",
                                      }}
                                    >
                                      {dropdownAmounts.map((amt) => (
                                        <div
                                          key={amt}
                                          onClick={() => {
                                            setSelectedAmount(amt);
                                            setShowDropdown(false);
                                          }}
                                          className="dropdown-item"
                                          style={{
                                            padding: "8px 16px",
                                            cursor: "pointer",
                                            backgroundColor:
                                              selectedAmount === amt
                                                ? "#f0f0f0"
                                                : "transparent",
                                          }}
                                        >
                                          ₹ {amt.toLocaleString("en-IN")}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-part">
                          <label htmlFor="phone">Mobile Number</label>
                          <input
                            type="tel"
                            placeholder="Phone Number"
                            maxLength={10}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            readOnly={user ? true : false}
                            {...register("phone", {
                              required: true,
                              pattern: {
                                value: /^[6-9]\d*$/,
                                message: "Please provide valid phone number",
                              },
                              minLength: {
                                value: 10,
                                message:
                                  "Phone number must be minimum 10 digits",
                              },
                            })}
                          />
                          {errors.phone?.type === "required" && (
                            <small className="text-danger error">
                              This is required
                            </small>
                          )}
                          {errors.phone?.message && (
                            <small className="text-danger error">
                              {errors.phone.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-part">
                          <label htmlFor="email">Email</label>
                          <input
                            type="email"
                            {...register("email", {
                              required: true,
                              pattern: {
                                value:
                                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: "Please enter a valid email",
                              },
                            })}
                            placeholder="Email"
                          />
                          {errors.email?.type === "required" && (
                            <small className="text-danger error">
                              This is required
                            </small>
                          )}
                          {errors.email?.message && (
                            <small className="text-danger error">
                              {errors.email.message}
                            </small>
                          )}
                        </div>
                      </div>
                      {!ics_data || ics_data == "" || !user ? (
                        <div className="col-md-6">
                          <div className="form-part">
                            <label htmlFor="">Name</label>
                            <input
                              maxLength={50}
                              type="text"
                              //onKeyUp={fetchNameFromIcs}
                              {...register("name", {
                                required: true,
                                maxLength: {
                                  value: 50,
                                  message:
                                    "Name can't exceeds more than 50 characters",
                                },
                                pattern: {
                                  value: /^[A-Za-z ]*$/,
                                  message: "Special Characters not allowed !",
                                },
                              })}
                              onKeyPress={(event) => {
                                if (/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              placeholder="Name"
                            />
                            {errors.name?.type === "required" && (
                              <small className="text-danger error">
                                This is required
                              </small>
                            )}
                            {errors.name?.message && (
                              <small className="text-danger error">
                                {errors.name?.message}
                              </small>
                            )}
                            {token ? (
                              <button
                                className="donation-link"
                                onClick={handelOptions}
                                type="button"
                              >
                                Select Options
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="col-md-6">
                          <div className="form-part">
                            <label htmlFor="">Select Name</label>
                            <select
                              {...register("name", {
                                required: true,
                                onChange: (e) => {
                                  handleSelectProfiles(e);
                                },
                              })}
                            >
                              {user ? (
                                <option value={user?.name} defaultValue>
                                  {user?.name}
                                </option>
                              ) : (
                                ""
                              )}
                              {ics_data.map((data, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </select>
                            {errors.donationType?.type === "required" && (
                              <small className="text-danger error">
                                This is required
                              </small>
                            )}
                            <button
                              className="donation-link"
                              onClick={handelOther}
                              type="button"
                              // style={{fontSize:'18px'}}
                            >
                              To enter new name click here
                            </button>
                          </div>
                        </div>
                      )}
                      <div className="col-md-6">
                        <div className="form-part">
                          <label htmlFor="">PAN (Optional)</label>
                          <Tooltip
                            title="For 80G reciept"
                            placement="bottom-start"
                          >
                            <input
                              type="text"
                              style={{ textTransform: "uppercase" }}
                              name=""
                              id=""
                              // onKeyUp={fetchPanFromIcs}
                              maxLength={10}
                              placeholder="PAN"
                              {...register("pan", {
                                pattern: {
                                  value: /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/,
                                  message: "Please enter valid PAN",
                                },
                              })}
                            />
                          </Tooltip>
                          {errors.pan?.type === "required" && (
                            <small className="text-danger error">
                              This is required
                            </small>
                          )}
                          {errors.pan && (
                            <small className="text-danger error">
                              {errors.pan.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-part">
                          <label htmlFor="">Address </label>
                          <Tooltip
                            title="For Prasadam please provide this"
                            placement="bottom-start"
                          >
                            <textarea
                              defaultValue={ics_address}
                              type="text"
                              {...register("address", {
                                minLength: {
                                  value: 10,
                                  message:
                                    "address must be minimum 10 characters",
                                },
                              })}
                              placeholder="Address"
                              {...register("address", {
                                required: true,
                              })}
                            ></textarea>
                          </Tooltip>
                          {errors.address?.type === "required" && (
                            <small className="text-danger error">
                              This is required
                            </small>
                          )}

                          {errors.address?.message && (
                            <small className="text-danger error">
                              {errors.address?.message}
                            </small>
                          )}
                          {/* {errors.address && (
                          <small className="error">
                            {errors.address.message}
                          </small>
                        )} */}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-part">
                          <label htmlFor="">PIN Code</label>
                          <input
                            defaultValue={ics_pincode}
                            type="text"
                            minLength={6}
                            maxLength={6}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            {...register("pin", {
                              pattern: {
                                value: /^\d+$/,
                                message: "PIN code must be number.",
                              },
                              onChange: (e) => {
                                setValue("state", "");
                                setValue("city", "");
                                if (e.target.value.length === 6) {
                                  fetchStateCity(e.target.value);
                                }
                              },
                            })}
                            {...register("pin", {
                              required: true,
                            })}
                            placeholder="PIN Code"
                          />
                          {errors.address?.type === "required" && (
                            <small className="text-danger error">
                              This is required
                            </small>
                          )}
                          {errors.pin && (
                            <small className="text-danger error">
                              {errors.pin.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="type_checkbox mt-3">
                          <input
                            type="checkbox"
                            id="memoryOfSomeone"
                            {...register("memoryOfSomeone")}
                          />
                          <label htmlFor="memoryOfSomeone">
                            This Donation in the memory/honor of someone or
                            performed on a specific occasion
                          </label>
                        </div>
                        {showMemoryBox && (
                          <div className="row">
                            <div className="col-lg-2 col-md-6">
                              <div className="form-part">
                                <label htmlFor="mrandms">Title</label>
                                <select {...register("mrandms")}>
                                  <option value="">Select Title</option>
                                  <option value="mrtitle">Mr</option>
                                  <option value="mstitle">Ms</option>
                                  <option value="latere">Late</option>
                                </select>

                                {errors.occasion?.message && (
                                  <small className="text-danger error">
                                    {errors.occasion?.message}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-part">
                                <label htmlFor="inNameOf">Name </label>
                                <input
                                  type="text"
                                  placeholder="In Name Of"
                                  {...register("inNameOf")}
                                />

                                {errors.inNameOf?.message && (
                                  <small className="text-danger error">
                                    {errors.inNameOf?.message}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                              <div className="form-part">
                                <label htmlFor="relationwithDonor">
                                  Relation
                                </label>
                                <input
                                  type="text"
                                  placeholder="Relation"
                                  {...register("relationwithDonor")}
                                />

                                {errors.relationwithDonor?.message && (
                                  <small className="text-danger error">
                                    {errors.relationwithDonor?.message}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                              <div className="form-part">
                                <label htmlFor="">Relative Mobile Number</label>
                                <input
                                  type="tel"
                                  placeholder="Phone Number"
                                  // onKeyUp={getIcsData}
                                  maxLength={10}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  // disabled=
                                  {...register("relativephone", {
                                    pattern: {
                                      value: /^[6-9]\d*$/,
                                      message:
                                        "Please provide valid phone number",
                                    },
                                    minLength: {
                                      value: 10,
                                      message:
                                        "Phone number must be minimum 10 digit",
                                    },
                                  })}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                              <div className="form-part">
                                <label htmlFor="occasion">Occasion</label>
                                <select {...register("occasion")}>
                                  <option value="birthday">
                                    Select Occasion
                                  </option>
                                  <option value="Birthday">Birthday</option>
                                  <option value="MarriageAnniversary">
                                    Marriage Anniversary
                                  </option>
                                  <option value="DeathAnniversary">
                                    Death Anniversary
                                  </option>
                                  <option value="OtherOccasion">
                                    Any Other Occasion
                                  </option>
                                </select>

                                {errors.occasion?.message && (
                                  <small className="text-danger error">
                                    {errors.occasion?.message}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                              <div className="form-part">
                                <label htmlFor="inDate">Occasion Date</label>
                                <div className="input-date">
                                  <input
                                    type="date"
                                    placeholder="Date"
                                    {...register("inDate")}
                                  ></input>
                                </div>
                              </div>
                            </div>
                            {/* <div className="form-part mt-2 memory_field">
                            <textarea
                              type="text"
                              {...register("memoryText")}
                            ></textarea>
                          </div> */}
                            <label htmlFor="">Message</label>
                            <textarea
                              type="text"
                              maxLength={250}
                              {...register("memoryText")}
                            ></textarea>
                            <small>* Minimum 250 characters allowed</small>
                          </div>
                        )}
                      </div>
                      <div className="col-12">
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                          ref={recaptchaRef}
                          size="invisible"
                        />
                      </div>
                      {/* <div className="col-12 mt-4">
                      <button
                        type="submit"
                        className="box-hover custom-btn-cls donation_btn ms-0 donate-now-clicked-form"
                        disabled={loading ? true : false}
                      >
                        {loading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border text-light"
                              role="status"
                            ></div>
                            <div className="ms-2">CONTRIBUTE...</div>
                          </div>
                        ) : (
                          <>

                            <>
                              CONTRIBUTE NOW &nbsp;&nbsp;
                              {totalAmount > 0 &&
                                `${totalAmount.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                  style: "currency",
                                  currency: "INR",
                                })}/-`}
                            </>

                          </>
                        )}
                      </button>
                      {showOtp && (
                        <>
                          <div className="form-part d-inline-block my-2">
                            <input
                              type="text"
                              placeholder="Enter OTP"
                              maxLength={6}
                              minLength={6}
                              value={otp}
                              onChange={(e) => setOtp(e.target.value)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                            {!showresendlink && showTimer && (
                              <span
                                style={{
                                  color: "#9F1D21",
                                  display: "inline-block",
                                  marginLeft: "10px",
                                }}
                              >
                                {getTime(otpExp)}s
                              </span>
                            )}
                          </div>
                          <>
                            {showresendlink && (
                              <button
                                className="custom-btn-cls box-hover"
                                onClick={resendOtp}
                              >
                                RESEND
                              </button>
                            )}
                          </>
                        </>
                      )}
                    </div> */}
                      <div className="col-12">
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                          ref={recaptchaRef}
                          size="invisible"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="container mt-2">
                      <div className="card">
                        <div className="card-body d-flex">
                          <div className="col" style={{ marginTop: "15px" }}>
                            <h2
                              className="summary-header  font-weight-bold"
                              style={{
                                fontSize: "12px",
                                marginBottom: "15px",
                                color: "#758497",
                              }}
                            >
                              Nitya Seva
                            </h2>
                            <h2
                              className="summary-header font-weight-bold"
                              style={{
                                fontSize: "12px",
                                marginBottom: "15px",
                                color: "#758497",
                              }}
                            >
                              Seva Duration
                            </h2>
                            <h2
                              className="summary-header font-weight-bold"
                              style={{
                                fontSize: "12px",
                                marginBottom: "15px",
                                color: "#758497",
                              }}
                            >
                              Total
                            </h2>
                          </div>
                          <svg
                            width="2"
                            height="107"
                            viewBox="0 0 2 107"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 0.932861L0.999995 105.748"
                              stroke="#9AA8B9"
                              stroke-opacity="0.19"
                              stroke-linecap="round"
                            />
                          </svg>

                          <div
                            className="col"
                            style={{ marginLeft: "10px", marginTop: "15px" }}
                          >
                            <h2
                              className="summary-header  font-weight-bold"
                              style={{
                                fontSize: "12px",
                                color: "#758497",
                                marginBottom: "15px",
                              }}
                            >
                              ₹{selectedAmount.toLocaleString("en-IN") || 0}
                            </h2>
                            <h2
                              className="summary-header font-weight-bold"
                              style={{
                                fontSize: "12px",
                                color: "#758497",
                                marginBottom: "15px",
                              }}
                            >
                              {getMonthYearRange()}
                            </h2>
                            <h2
                              className="summary-header font-weight-bold"
                              style={{
                                fontSize: "12px",
                                color: "#758497",
                                marginBottom: "15px",
                              }}
                            >
                              ₹{selectedAmount.toLocaleString("en-IN") || 0}
                              /month
                            </h2>
                          </div>

                          {/* <table className="table mt-4">
                            <thead>
                              <tr>
                                <th style={{ fontSize: "12px" }}>SCHEME</th>
                                <th style={{ fontSize: "12px" }}>SUBTOTAL</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ fontSize: "11px" }}>
                                  {selectedSeva || "Nitya Seva"} ₹
                                  {selectedAmount || 0} × 1
                                </td>
                                <td style={{ fontSize: "11px" }}>
                                  ₹{selectedAmount || 0} / month for 12 months
                                </td>
                              </tr>
                              <tr className="font-weight-bold">
                                <td style={{ fontSize: "11px" }}>Total</td>
                                <td style={{ fontSize: "11px" }}>
                                  ₹{selectedAmount || 0}
                                </td>
                              </tr>
                            </tbody>
                          </table> */}
                          {/* <h4 style={{ fontSize: "12px" }}>
                            Monthly Subscriptions
                          </h4>
                          <p style={{ fontSize: "12px" }}>
                            Payment will be debited automatically every month
                            for One Year
                          </p> */}
                        </div>
                        <div
                          className="col-12 mt-0 d-flex flex-column align-items-center text-center"
                          style={{ marginLeft: "5px" }}
                        >
                          <h2
                            className="summary-header font-weight-bold"
                            style={{ fontSize: "12px", color: "#758497" }}
                          >
                            ₹{selectedAmount.toLocaleString("en-IN")} will be
                            auto-debited monthly from your bank account.
                          </h2>
                          {/* <button
                            type="submit"
                            className="box-hover custom-btn-cls donation_btn ms-0 donate-now-clicked-form"
                            disabled={loading}
                          >
                            {loading ? (
                              <div className="d-flex align-items-center">
                                <div
                                  className="spinner-border text-light"
                                  role="status"
                                ></div>
                                <div
                                  className="ms-2"
                                  style={{
                                    fontSize: "12px",
                                    color: "#AA3236",
                                    fontWeight: "bold",
                                  }}
                                >
                                  STARTING...
                                </div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#AA3236",
                                  fontWeight: "bold",
                                }}
                              >
                                START MY MONTHLY SEVA
                                
                              </div>
                            )}
                          </button> */}

                          <button
                            type="submit"
                            className="cta-button-submit"
                            disabled={loading}
                          >
                            {loading ? (
                              <div className="d-flex align-items-center justify-content-center">
                                <div
                                  className="spinner-border spinner-border-sm text-light"
                                  role="status"
                                ></div>
                                <span
                                  className="ms-2"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                  }}
                                >
                                  STARTING...
                                </span>
                              </div>
                            ) : (
                              <span
                                style={{ fontSize: "14px", fontWeight: "600" }}
                              >
                                START MY MONTHLY SEVA
                              </span>
                            )}
                          </button>

                          {showOtp && (
                            <>
                              <div className="form-part d-inline-block my-2">
                                <input
                                  type="text"
                                  placeholder="Enter OTP"
                                  maxLength={6}
                                  minLength={6}
                                  value={otp}
                                  onChange={(e) => setOtp(e.target.value)}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                                {!showresendlink && showTimer && (
                                  <span
                                    style={{
                                      color: "#9F1D21",
                                      display: "inline-block",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {getTime(otpExp)}s
                                  </span>
                                )}
                              </div>
                              {showresendlink && (
                                <button
                                  className="custom-btn-cls box-hover"
                                  onClick={resendOtp}
                                >
                                  RESEND
                                </button>
                              )}
                            </>
                          )}
                          <div className="d-flex justify-center items-center gap-2">
                            <svg
                              width="7"
                              height="10"
                              viewBox="0 0 7 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.95 3.71795V3.18488C5.95 1.7377 4.85311 0.564514 3.5 0.564514C2.14689 0.564514 1.05 1.7377 1.05 3.18488V3.71795C0.413012 4.01528 0.000918751 4.68759 0 5.43092V7.67695C0.00114844 8.71015 0.783974 9.54743 1.74999 9.54865H5.24999C6.21601 9.54743 6.99884 8.71015 7 7.67695V5.43092C6.9991 4.68759 6.58699 4.01528 5.95 3.71795ZM3.85 6.92829C3.85 7.13503 3.6933 7.30262 3.5 7.30262C3.3067 7.30262 3.15 7.13503 3.15 6.92829V6.1796C3.15 5.97286 3.3067 5.80527 3.5 5.80527C3.6933 5.80527 3.85 5.97286 3.85 6.1796V6.92829ZM5.25001 3.55923H1.74999V3.1849C1.74999 2.1512 2.53349 1.3132 3.5 1.3132C4.46651 1.3132 5.25001 2.15118 5.25001 3.1849V3.55923Z"
                                fill="#A6ADB7"
                              />
                            </svg>
                            <div>
                              <h2
                                className="summary-header font-weight-bold"
                                style={{ fontSize: "9px", color: "#A6ADB7" }}
                              >
                                Your seva is secure
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )}
          {/* <div className="donate-note my-5">
            <p>
              Note: AVAIL 80G BENEFITS ON THE DONATIONS MADE TO ISKCON ATTAPUR (Preaching center- ISKCON HYDERABAD) AS PER THE INCOME TAX ACT 1961 AND RULES MADE THERE UNDER.

            </p>
            <p>
              "Exemption order ref no. AAATI0017PF2021901 dated 24/09/2021 valid
              upto 31/03/2026"
            </p>
          </div> */}
          <div className="col-md-12">
            {/* <figure className="mb-0">
                <img
                  className="w-100"
                  src="/images/page-header/nitya-seva-bvanner.jpg"
                  alt="Nitya Seva image"
                />
              </figure> */}
            <div id="scrollToDonationForm" className="nitya-seva-heading">
              <h2 className="head-1 mt-3" style={{}}>
                WHY CHOOSE NITYA SEVA?
              </h2>

              <p style={{ textAlign: "justify" }}>
                Nitya Seva is more than giving, it’s an offering from the heart.
                By contributing regularly, you become part of an ongoing
                spiritual journey that supports daily worship of Sri Sri Radha
                Madhava and helps us serve the needy in a more organized and
                meaningful way. More than a donation, Nitya Seva is a simple way
                to serve regularly and grow spiritually over time.
              </p>
            </div>
            <div className="card-slider-wrapper">
              <div className="row row-cols-1 row-cols-md-4 g-4 mt-4 card-slider">
                {cardItems.map((item, index) => (
                  <div className="col d-flex" key={index}>
                    <div
                      className="card h-100 w-100 p-4"
                      style={{ borderColor: "#FFC84F" }}
                    >
                      <div
                        className="p-2"
                        style={{
                          backgroundColor: "#FFC84F2B",
                          display: "flex",
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.svg}
                      </div>
                      <div className="card-body d-flex flex-column mt-2">
                        <h5
                          className={`card-title text-maroon`}
                          style={{
                            color: "#9F1D21",
                          }}
                        >
                          {item.title}
                        </h5>
                        <p
                          className="card-text"
                          style={{
                            color: "#758497",
                          }}
                        >
                          {item.text}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className="col-md-12 how-nitya-seva"
            style={{
              backgroundColor: "#AA3236",
              padding: "10px",
              marginTop: "4%",
            }}
          >
            <div id="scrollToDonationForm" className="headingNow">
              <h2
                className="head-1 mt-3"
                style={{ textAlign: "center", color: "#F3B01B" }}
              >
                HOW NITYA SEVA WORKS
              </h2>

              <p className={isMobile ? "responsive-text" : ""}>
                Join in just four simple steps and turn your giving into a
                meaningful spiritual offering.
              </p>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-3">
              {donationSteps.map((step, index) => (
                <div className="col" key={index}>
                  <div
                    className="card h-100 p-3"
                    style={{
                      backgroundColor: "transparent",
                      borderColor: "#FFC84F",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderRadius: "12px",
                      width: "80%",
                      marginLeft: index % 2 === 0 ? "20%" : "0", // 0-based index: 0 & 2 → cards 1 & 3
                    }}
                  >
                    <div className="d-flex align-items-start gap-3">
                      <div
                        style={{
                          backgroundColor: "#FFC84F2B",
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexShrink: 0,
                        }}
                      >
                        {step.svg}
                      </div>

                      <div className="d-flex flex-column">
                        <h6 style={{ color: "#FFC84F", marginBottom: "2px" }}>
                          {step.No}
                        </h6>
                        <h5 style={{ color: "#FFFFFF", marginBottom: "4px" }}>
                          {step.title}
                        </h5>
                        <p
                          className="mb-0"
                          style={{ color: "#FFFFFF", fontSize: "0.9rem" }}
                        >
                          {step.text}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className="col-md-12 benefits-section"
            style={{
              backgroundColor: "#FFFFFF",
              padding: "10px",
              marginTop: "4%",
            }}
          >
            <div id="scrollToDonationForm" className="nitya-seva-heading">
              <h2 className="head-1 mt-3" style={{ textAlign: "center" }}>
                BENEFITS FOR YOU
              </h2>

              <p className={isMobile ? "responsive-text" : ""}>
                Nitya Seva is designed to benefit both recipients and donors,
                creating a meaningful connection through regular giving.
              </p>
            </div>
            <div className="row row-cols-1 row-cols-md-3 g-4 mt-3">
              {cardData.map((card, index) => (
                <div className={`col ${card.styleClass || ""}`} key={index}>
                  <div className="card h-100 d-flex flex-column justify-content-center align-items-center text-center pt-5 pb-5 card-grid">
                    {card.svg}
                    <div className="card-body">
                      <h5 className="card-title text-custom-red">
                        {card.title}
                      </h5>
                      <p className="card-text text-custom-descript">
                        {card.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <div
            className="col-md-12 impact-stories-section"
            style={{
              backgroundColor: "#FFF5DC",
              padding: "10px",
              marginTop: "4%",
            }}
          >
            <div id="scrollToDonationForm" className="nitya-seva-heading">
              <h2 className="head-1 mt-3" style={{ textAlign: "center" }}>
                IMPACT STORIES
              </h2>

              <p
                style={{
                  textAlign: "center",
                  color: "#758497",
                }}
              >
                Hear from donors who have experienced the transformative power
                of regular giving through Nitya Seva.
              </p>
            </div>
            <div
              className="testimonial-container"
              style={{ backgroundColor: "#FFF5DC", padding: "40px 40px" }}
            >
              <Splide
                options={{
                  perPage: 3,
                  gap: "1rem",
                  pagination: true,
                  arrows: false,
                  breakpoints: {
                    768: {
                      perPage: 1,
                    },
                    1024: {
                      perPage: 2,
                    },
                  },
                }}
                aria-label="Testimonials"
              >
                {testimonials.map((item, index) => (
                  <SplideSlide key={index}>
                    <div
                      style={{
                        background: "#fff",
                        padding: "30px",
                        borderRadius: "10px",
                        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          fontStyle: "italic",
                          color: "#334155",
                          fontSize: "1rem",
                        }}
                      >
                        {item.text}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "20px",
                        }}
                      >
                        <img
                          src={item?.image}
                          alt={item?.name}
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginRight: "15px",
                          }}
                        />
                        <div>
                          <div style={{ color: "#42546A" }}>
                            {item?.name}
                          </div>
                          <div style={{ fontSize: "0.9rem", color: "#42546A" }}>
                            {item.city}
                          </div>
                        </div>
                      </div>
                    </div>
                  </SplideSlide>
                ))}
              </Splide>
            </div>
            <div className="cta-container align-items-center mb-2">
                <div className="caption-down">
                Join thousands of regular givers making a difference
                </div>
                <button
                  className="cta-button"
                  onClick={() => setShownForm(true)}
                >
                  START MY MONTHLY SEVA
                </button>
              </div>
          </div> */}
        </div>
      </section>
      <GoToTop top={top} />
    </>
  );
};

export default NityaSevaForm;

// We thank you for your commitment to contribute to the cause, on a regular basis.
